// Translations for the 23 treatment pages.
// Shape: { "/slug": { title, eyebrow, lead, cta, heroAlt, stats, candidate,
//   techniques, journey, risks, faq, ctaBand, disclaimer, seoTitle, seoDesc } }
export default {
  "/abdominoplasty": {
    "title": "İstanbul'da Karın Germe (Abdominoplasti)",
    "eyebrow": "Vücut şekillendirme",
    "lead": "Karın germe, diyet ve egzersizle gitmeyen fazla deriyi ve yağı alır, altındaki karın duvarını sıkılaştırır. Bir kilo verme ameliyatı değil, vücut şekillendirme işlemidir.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te karın germe ön görüşmesi",
    "stats": [
      {
        "value": "2–4 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "1–2 gece",
        "label": "Hastanede kalış"
      },
      {
        "value": "2–3 hafta",
        "label": "Masa başı işe dönüş"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Ameliyat en iyi, kilosu en az altı aydır sabit olan, genel sağlığı iyi olan ve derdi kilogram değil vücut şekli olan kişilerde işe yarar.",
      "items": [
        "Hamilelik sonrası gevşek deri veya birbirinden ayrılmış karın kasları",
        "Belirgin kilo kaybı sonrası, kilo artık sabitlendiğinde sarkan deri",
        "Egzersizle değişmeyen, inatçı alt karın bölgesi",
        "Zaten alınacak derinin içinde kalacak çatlaklar veya sezaryen izi"
      ],
      "note": "Karın germe obezite tedavisi değildir ve kilo vermenin yerini tutmaz. Hamilelik planlıyorsanız ya da büyük miktarda kilo vermeyi bekliyorsanız genellikle beklemek daha iyidir — sonucun kalıcı olması hedeflenir."
    },
    "techniques": {
      "heading": "Neler yapılabilir, teknik nasıl seçilir",
      "intro": "Teknik, tek başına fotoğrafa bakılarak değil; deriye, kas tabakasına ve iz düzenine göre görüşmede seçilir.",
      "items": [
        {
          "name": "Tam karın germe",
          "text": "Karın alt kısmında yatay bir kesi, deri kaburgalara kadar kaldırılır, karın kasları orta hatta sıkılaştırılır ve fazla deri alınır. Göbek yeniden konumlandırılır. Hamilelik sonrası sık görülen rektus (karın kası) ayrılması da bu sırada onarılır. Göbeğin üstünde ve altında gevşek derisi olanlar için uygundur."
        },
        {
          "name": "Mini karın germe",
          "text": "Alt karınla sınırlı deri gevşekliği için daha kısa bir kesi ve daha kısa iyileşme süresi. Göbek genellikle yerinde bırakılır; kas sıkılaştırması sınırlıdır."
        },
        {
          "name": "Genişletilmiş karın germe",
          "text": "Tam karın germenin yanlara doğru uzatılmış hâli; yanlarda da sarkan deri için. Sıklıkla bel bölgesi liposuction'ı ile birleştirilir."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden iyileşmeye",
      "steps": [
        {
          "name": "Görüşme ve planlama",
          "text": "Fotoğraflar, tıbbi geçmiş; izler, işten uzak kalma süresi ve ameliyatın yapabilecekleri ile yapamayacakları üzerine dürüst bir konuşma. Tarih belirlenmeden önce kan testleri, gerektiğinde ultrason veya kardiyoloji görüşü planlanır."
        },
        {
          "name": "Hazırlık",
          "text": "Sigara en az üç–dört hafta önce bırakılır, kan sulandırıcılar ve bazı takviyeler yaklaşık on gün önce kesilir, altı–sekiz saat açlık gerekir. Sizi eve götürecek ve ilk hafta yardımcı olacak birini ayarlayın."
        },
        {
          "name": "Ameliyat",
          "text": "Genel anestezi altında, genellikle iki–dört saat. Sıklıkla birkaç gün dren bırakılır. Hastaların çoğu bir–iki gece hastanede kalır; taburculuktan önce korse giydirilir."
        },
        {
          "name": "İlk iki hafta",
          "text": "İlk günden itibaren kısa mesafelerde, sırt dik yürünür. Korse gece gündüz giyilir. Şişlik üçüncü–beşinci günlerde zirve yapar ve sonra iner; ilk duş ve dren çıkarılması klinikte planlanır."
        },
        {
          "name": "Üçüncü hafta ve sonrası",
          "text": "Masa başı işe genellikle iki–üç hafta sonra dönülür. Spor salonu, yüzme ve ağır kaldırma, cerrahın dokunun iyileştiğini onayladığı altıncı haftaya kadar bekler. İz ilk aylarda kırmızı ve serttir, sonra solar ve düzleşir; bu süreç on iki–on sekiz ay sürer ve iz düşük, iç çamaşırı çizgisinin içinde kalır."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Her ameliyatın riski vardır ve bunları karar vermeden önce duymak gerekir, sonra değil.",
      "items": [
        "Seroma — deri altında sıvı birikmesi; en sık görülen sorun, genellikle klinikte boşaltılır",
        "Enfeksiyon veya gecikmiş yara iyileşmesi; sigara içenlerde daha olası",
        "Kanama, morarma ve nadiren tromboz — erken yürüyüş ve kompresyonla önlenir",
        "Geniş veya kabarık iz ile asimetri ya da küçük bir revizyon gerektiren kontur (yaklaşık on hastada bir); iz sonradan düzeltilebilir ama silinemez",
        "İz çevresinde ve göbekte uyuşma; genellikle aylar içinde düzelir"
      ],
      "note": "Görüşmede sigarayı, diyabeti, kan sulandırıcıları ve geçirdiğiniz karın ameliyatlarını söyleyin. Her biri planı değiştirir ve birini saklamak, zorlu bir iyileşmeye giden en kısa yoldur."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ağrı olur mu?",
          "a": "İlk iki–üç gün ağrıdan çok rahatsızlık hissedilir; karında gergin, morarmış bir his. Sıradan ağrı kesicilerle yönetilir ve hastaların çoğu taburcu olmadan yürür ve normal yemek yer."
        },
        {
          "q": "İz belli olacak mı?",
          "a": "Bir iz kalır ve kalıcıdır. Düşük, iç çamaşırı çizgisi boyunca yerleştirilir ve on iki–on sekiz ayda solar. Nasıl iyileşeceği derinize, sigara içmemenize ve yara bakımı talimatlarına uymanıza bağlıdır."
        },
        {
          "q": "Sonrasında çocuk sahibi olabilir miyim?",
          "a": "Genellikle evet, ancak hamilelikte karın yeniden gerilir ve sonucun bir kısmı kaybolabilir. Bu nedenle birçok cerrah önce çocuk sahibi olmanızı tamamlamanızı önerir."
        },
        {
          "q": "Maliyeti ne kadar?",
          "a": "Fiyat tekniğe, hastaneye, kalış süresine ve kas onarımı gerekip gerekmediğine bağlıdır; bu yüzden önceden değil, değerlendirmeden sonra verilir. Teklif ameliyatı, anesteziyi, hastane konaklamasını, korseleri ve kontrol muayenelerini kapsar."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Bir cerrah fotoğrafları inceler, koordinatörümüz plan, tarih ve yazılı fiyat teklifiyle size döner — hiçbir yükümlülük ve randevu baskısı yok.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Bu sayfa genel bilgilendirme amaçlıdır, tıbbi tavsiye değildir. Uygunluk, teknik ve riskler bir cerrahla yapılan görüşmede belirlenir.",
    "seoTitle": "Karın Germe (Abdominoplasti) İstanbul | Platinya",
    "seoDesc": "İstanbul'da karın germe: teknikler, uygun adaylar, iyileşme süreci ve riskler. Platinya Clinic'te ücretsiz ön değerlendirme ile planınızı öğrenin."
  },
  "/hair-transplant": {
    "title": "İstanbul'da Saç Ekimi (FUE)",
    "eyebrow": "Saç restorasyonu",
    "lead": "Saç folikülleri, saç derisinin arkasından — dökülmeye dirençli oldukları bölgeden — seyrelmiş alanlara taşınır. Sonuç, artık orada uzamayan kendi saçınızdır.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te saç ekimi değerlendirmesi",
    "stats": [
      {
        "value": "6–9 saat",
        "label": "İşlem süresi"
      },
      {
        "value": "1 gün",
        "label": "Klinikte"
      },
      {
        "value": "12–18 ay",
        "label": "Nihai sonuç"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Sınırlayıcı etken ne kadar saçın eksik olduğu değil, arkada ve yanlarda ne kadar donör saç bulunduğu ve kaybın ne kadar sabit kaldığıdır.",
      "items": [
        "Yaklaşık bir yıldır sabit olan, haftalar içinde dökülmeyen saç kaybı",
        "Kel alanın ihtiyaç duyduğu greft sayısına yetecek donör yoğunluğu",
        "Gerileyen saç çizgisi, şakak kaybı veya tepe bölgesinde seyrelme",
        "Gerçekçi beklentiler: yoğunluk artar, ancak kel bir alan asla gençlik yoğunluğuna dönmez"
      ],
      "note": "Kayıp hâlâ aktifse, önce tıbbi olarak tedavi etmek sonucu korur. Ekim saçı taşır; hâlâ sahip olduğunuz saçın ileride seyrelmesini durdurmaz."
    },
    "techniques": {
      "heading": "Saç nasıl alınır ve yerleştirilir",
      "intro": "Yöntem; donör yoğunluğuna, alanın büyüklüğüne ve korumak istediğiniz saç modeline göre seçilir.",
      "items": [
        {
          "name": "FUE — foliküler ünite ekstraksiyonu",
          "text": "Foliküller tek tek alınır ve yeniden yerleştirilir. Deri şeridi çıkarılmadığı için doğrusal iz kalmaz; karşılığında donör alan kazınır ve iyileşme birkaç gün sürer."
        },
        {
          "name": "DHI — doğrudan saç ekimi",
          "text": "Foliküller tek kullanımlık bir ekim kalemiyle yerleştirilir; bu, saç çizgisinde açı ve derinliğin sıkı kontrolünü sağlar. Daha yavaş olduğu için seans başına daha az greft."
        },
        {
          "name": "Saç çizgisi tasarımı",
          "text": "Çizgi, herhangi bir kesim yapılmadan önce sizinle birlikte, otururken ve ayakta çizilir: yaşlanmaya ve ilerideki kayba dayanmalıdır; bu yüzden düşük değil, temkinli yerleştirilir."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden nihai sonuca",
      "steps": [
        {
          "name": "Değerlendirme",
          "text": "Donör yoğunluğu ölçülür, saç çizgisi tasarlanır ve kan testleri planlanır. Sonraki karşılaştırma için beş açıdan fotoğraf çekilir."
        },
        {
          "name": "Ameliyat günü",
          "text": "Hafif sedasyonlu lokal anestezi; uyanıksınız ve yemek yiyebilirsiniz. Seans uzundur — altı–dokuz saat — ve kısa molalarla bölünür."
        },
        {
          "name": "İlk on gün",
          "text": "Küçük kabuklar oluşur ve ikinci günden itibaren nazikçe yıkanır. Alında şişlik sık görülür ve bir hafta içinde iner."
        },
        {
          "name": "3.–12. haftalar",
          "text": "Ekilen saçın çoğu dökülür — bu beklenir ve başarısızlık anlamına gelmez. Yeni büyüme yaklaşık üçüncü ayda başlar."
        },
        {
          "name": "12. aydan itibaren",
          "text": "Yoğunluk ve kalınlık 12–18 aya kadar artmaya devam eder. İstenirse yoğunluk eklemek için ikinci seans, 12 aydan önce olmamak kaydıyla planlanır."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Ekim, gerçek sınırları olan gerçek bir ameliyattır. Randevu almadan önce bilinmesi gerekenler bunlar.",
      "items": [
        "İlk haftada şişlik, kızarıklık ve kabuklanma; saç derisinde geçici uyuşma",
        "Folikül yaşaması hiçbir zaman %100 değildir; greftlerin bir kısmı büyümez",
        "Planlanan greft sayısı donör arzıyla karşılanmazsa düzensiz veya seyrek kapsama",
        "Folikülit — alıcı alanda küçük enfekte noktalar, genellikle tedavi edilebilir",
        "Tasarım donör alan için çok düşük veya çok yoğun olduğunda doğal olmayan saç çizgisi"
      ],
      "note": "Planı en düşük fiyata göre değil, greft sayısına ve donör kalitesine göre seçin: donör alanı aşırı tüketen ucuz bir seans geri alınamaz."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ağrılı mı?",
          "a": "Enjeksiyonlar birkaç saniye yakar; sonrasında saç derisi uyuşur ve işlem ağrıdan çok sıkıcıdır. İlk gece hassastır ve sıradan ağrı kesicilerle geçer."
        },
        {
          "q": "İz kalacak mı?",
          "a": "FUE donör alanda, normal saç uzunluğunda neredeyse görünmez olacak kadar solan küçük yuvarlak izler bırakır. Şerit cerrahisi saç derisinin arkasında ince bir çizgi bırakır."
        },
        {
          "q": "Ne zaman işe dönebilirim?",
          "a": "Şişlik indikten sonra, iki–üç gün içinde masa başı işe dönülür. Ağır egzersiz, sauna ve yüzme yaklaşık iki hafta bekler."
        },
        {
          "q": "Yeni saç kalıcı mı?",
          "a": "Ekilen foliküller donör alanın davranışını korur ve genellikle kalıcıdır. Çevrelerindeki saç hâlâ seyrelebilir; tıbbi tedavinin sıklıkla sürdürülmesinin nedeni budur."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Saç çizgisi, tepe bölgesi ve donör alan fotoğrafları, ekimin mantıklı olup olmadığını, kabaca kaç greft gerektiğini ve maliyetini söylemek için yeterli.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk ancak saç derisi ve tıbbi geçmiş incelendikten sonra belirlenebilir; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "İstanbul'da Saç Ekimi (FUE) | Platinya Clinic",
    "seoDesc": "İstanbul'da saç ekimi: FUE ve DHI teknikleri, saç çizgisi tasarımı, iyileşme takvimi ve riskler. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/sapphire-hair-transplant": {
    "title": "İstanbul'da Safir FUE Saç Ekimi",
    "eyebrow": "Saç restorasyonu",
    "lead": "Safir FUE, standart FUE ile aynı foliküler ünite alımıdır; ancak greftler için kanallar çelik yerine safir bıçaklarla açılır. Fark foliküllerde değil, kesilerdedir.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te safir FUE saç ekimi planlaması",
    "stats": [
      {
        "value": "6–8 saat",
        "label": "İşlem süresi"
      },
      {
        "value": "1 gün",
        "label": "Klinikte"
      },
      {
        "value": "10–14 gün",
        "label": "Kabukların geçmesi"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Safir bir tekniktir, uygunluk testi değil: her ekimde olduğu gibi aynı kurallar geçerlidir — sabit kayıp ve yeterli donör saç.",
      "items": [
        "Arkada ve yanlarda sağlıklı donör alanla birlikte sabit saç kaybı",
        "Saç çizgisinde, şakaklarda veya tepe bölgesinde yalnızca tıbbi tedavinin çözemediği seyrelme",
        "Alıcı alanda aktif enfeksiyon, egzama veya sedef olmayan sağlıklı deri",
        "Bıçağın iyileşmeyi değiştirdiğini, karşılayabileceğiniz greft sayısını değiştirmediğini anlamak"
      ],
      "note": "Safiri daha yoğun saç garantisi olarak pazarlayan klinikler aracı abartıyordur. Greftlerin yaşaması, foliküllerin nasıl ele alındığına bağlıdır; yalnızca bıçağa değil."
    },
    "techniques": {
      "heading": "Safir bıçağın değiştirdiği şey",
      "intro": "Aynı ameliyat, farklı bir kesici ağız ve farklı bir dizi ödünleşmeyle.",
      "items": [
        {
          "name": "Daha dar kanallar",
          "text": "Safir bıçaklar çelikten daha ince bir yarık açar; doku yırtılmak yerine ayrılır. Daha küçük açıklıklar daha az kabuklanma ve çoğu hastada daha hızlı iyileşme demektir."
        },
        {
          "name": "Daha sıkı greft uyumu",
          "text": "Kanalına sıkıca oturan bir greftin ilk günlerde kayma olasılığı daha düşüktür. Bu en çok, yön ve açının göründüğü saç çizgisinde önemlidir."
        },
        {
          "name": "Değiştirmediği şey",
          "text": "Donör alanınızın verebileceği greft sayısını artırmaz ve planın yerini tutmaz: yoğunluk, saç çizgisi tasarımı ve ekibin folikülleri nasıl ele aldığı sonucu belirler."
        }
      ]
    },
    "journey": {
      "heading": "Ameliyat günü, saat saat",
      "steps": [
        {
          "name": "Tasarım ve tıraş",
          "text": "Saç çizgisi herhangi bir kesim yapılmadan önce çizilir ve üzerinde anlaşılır. Donör alan kısa kesilir; alıcı alan çoğu olguda kazınır."
        },
        {
          "name": "Anestezi",
          "text": "Hafif sedasyonla lokal anestezik enjeksiyonlar. Rahatsızlık ilk dakikalarla sınırlıdır."
        },
        {
          "name": "Alım ve kanallar",
          "text": "Foliküller alınır, solüsyon içinde serin tutulur ve safir kanallar saç çizgisinin ihtiyaç duyduğu açıyla açılır."
        },
        {
          "name": "Yerleştirme",
          "text": "Greftler tek tek yerleştirilir. Ekip, uzun seanslarda ele almanın tutarlılığını korumak için vardiyalar hâlinde çalışır."
        },
        {
          "name": "İyileşme",
          "text": "Küçük kabuklar 10–14 günde dökülür. Ekilen saç üçüncü haftadan itibaren dökülür, sonra üçüncü aydan itibaren yeniden uzar."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Her ekim, bıçak ne olursa olsun aynı temel riskleri taşır.",
      "items": [
        "Donör ve alıcı alanlarda şişlik, hassasiyet ve geçici uyuşma",
        "Hassas deride beklenenden uzun süren kabuklanma ve kızarıklık",
        "Bazı greftler yaşamaz; ikinci seansın bazen gerekmesinin nedeni budur",
        "İlk haftalarda yeni greftlerin çevresinde folikülit veya küçük kistler",
        "Tasarım temkinli yapılmadıysa fazla düz veya fazla yoğun görünen saç çizgisi"
      ],
      "note": "Kaç greft planlandığını, kanalları kimin açtığını ve kimin ektiğini sorun — cevaplar size sonuç hakkında «safir» kelimesinden daha fazlasını söyler."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Safir, çelik FUE'den daha mı iyi?",
          "a": "Biraz daha hızlı iyileşir ve daha az kabuklanma yapar. Daha fazla saç çıkardığına dair bağımsız kanıt zayıftır; cerrahın greftleri ele alışı daha önemlidir."
        },
        {
          "q": "Daha mı çok acıyor?",
          "a": "Hayır. Anestezi aynıdır; bıçak uyuşmuş deride kullanılır."
        },
        {
          "q": "Kabuklar ne zaman geçer?",
          "a": "Genellikle 10–14 gün içinde, ikinci günden itibaren nazik yıkamayla."
        },
        {
          "q": "Bir seans yeterli mi?",
          "a": "Birçok hasta için evet. Geniş kel alanlar veya düşük donör yoğunluğu, planlanan yoğunluğa ulaşmak için 12 ay sonra ikinci bir seans gerektirebilir."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Safir FUE'nin sizin olgunuzda bir şey katıp katmadığını ve greft sayısının ne olacağını dürüstçe söyleriz.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk muayeneden sonra belirlenir; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "Safir FUE Saç Ekimi İstanbul | Platinya Clinic",
    "seoDesc": "İstanbul'da safir FUE saç ekimi: safir bıçak kanalları, çelik FUE ile farkı, iyileşme takvimi ve riskler. Ücretsiz değerlendirme."
  },
  "/hair-implant-hybrid": {
    "title": "İstanbul'da Hibrit Saç Ekimi (FUE + FUT)",
    "eyebrow": "Saç restorasyonu",
    "lead": "Hibrit seans, saç almanın iki yolunu — saç derisinin arkasından ince bir şerit ve tek tek foliküler üniteler — tek ameliyatta birleştirir; bu, tek yöntemin kel alanın ihtiyaç duyduğu greft sayısını veremediği durumlarda yapılır.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te hibrit saç ekimi tekniği karşılaştırması",
    "stats": [
      {
        "value": "1 seans",
        "label": "İki teknik"
      },
      {
        "value": "+%30–50",
        "label": "Yalnız FUE'ye göre greft"
      },
      {
        "value": "12 ay",
        "label": "Sonucu değerlendirme"
      }
    ],
    "candidate": {
      "heading": "Kimler için uygun",
      "intro": "Hibrit, iki araçla çözülen bir kaynak sorunudur: geniş kel alanlar ve tek başına alımla her şeyi veremeyecek kadar seyrek bir donör alan için vardır.",
      "items": [
        "İleri düzey kayıp — Norwood 5–6 — ve tek FUE seansının tepe bölgesini seyrek bırakacağı durumlar",
        "Şerit bölgesinde iyi yoğunluk, ancak alım için sınırlı foliküler ünite",
        "Erişilebilir donör alanları tüketmiş önceki bir FUE seansı",
        "Belirgin biçimde daha fazla greft karşılığında ince bir doğrusal izi kabul etmeye istekli olmak"
      ],
      "note": "Daha fazla greft otomatik olarak daha iyi değildir. Hibrit, plan gerçekten ek sayılara ihtiyaç duyuyorsa anlamlıdır; daha küçük alanlarda tek teknik daha basittir ve daha hızlı iyileşir."
    },
    "techniques": {
      "heading": "İki yarı nasıl birlikte çalışır",
      "intro": "Önce şerit alınır, sonra alım planın geri kalanını tamamlar — tek anestezi, tek gün.",
      "items": [
        {
          "name": "Şerit (FUT)",
          "text": "Saç derisinin arkasından dar bir elips çıkarılır, katmanlar hâlinde kapatılır ve mikroskop altında tek tek greftlere ayrılır. Santimetre kare başına en yoğun greft kaynağıdır."
        },
        {
          "name": "Alım (FUE)",
          "text": "Ardından yanlardan foliküller tek tek alınır; bu, ikinci bir iz hattı olmadan greft ekler — ve daha önemlisi, şeridin kapatılmasını seyreltmez."
        },
        {
          "name": "Neden sadece daha fazla FUE yapılmıyor",
          "text": "Çünkü donör alanı aşırı hasat etmek onu düzensiz bırakır ve gelecekteki herhangi bir seansın kapısını kapatır. Hibrit yükü iki donör bölgesine yayar."
        }
      ]
    },
    "journey": {
      "heading": "Planlamadan nihai sonuca",
      "steps": [
        {
          "name": "Greft bütçesi",
          "text": "Şerit bölgesindeki ve alım bölgesindeki donör yoğunluğu ayrı ayrı ölçülür ve her birinin verebileceği greft sayısı toplanır. Bu toplam planı belirler."
        },
        {
          "name": "Ameliyat günü",
          "text": "Şeridin alınması yaklaşık bir saat sürer; ekip bir yandan greftleri ayırırken alım devam eder. Büyük bir seansta toplam sekiz–on saat bekleyin."
        },
        {
          "name": "İlk iki hafta",
          "text": "Şerit hattı dikiş veya zımba ile kapatılır; bunlar 10.–14. günlerde alınır. Alıcı alandaki kabuklar da aynı dönemde temizlenir."
        },
        {
          "name": "1.–3. aylar",
          "text": "Ekilen saç dökülür, ardından yeniden büyüme başlar. Doğrusal iz kırmızıdan soluk renge döner."
        },
        {
          "name": "12.–18. ay",
          "text": "Nihai yoğunluk. Normal saç uzunluğunda şerit izi genellikle çevredeki saçla örtülür; çok kısa kesimlerde görünür."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Hibrit, iki tekniğin risklerini aynı anda taşır.",
      "items": [
        "Saç derisinin arkasında, normal uzunlukta saçla gizlenen kalıcı doğrusal iz",
        "Kapatma gergin yapıldıysa veya iyileşme kötüyse izde gerginlik veya genişleme",
        "İzin üstünde, düzelmesi aylar alabilen geçici uyuşma",
        "Her ekimin olağan riskleri: şişlik, folikülit, kısmi greft kaybı",
        "Uzun seans — yorgunluk hem hastayı hem ekibi etkiler; günün aşamalara bölünmesinin nedeni budur"
      ],
      "note": "Şeridi kimin kapatacağını ve kliniğin ayda kaç hibrit seans yaptığını sorun. Hastaların yıllar sonra değerlendirdiği kısım kapatmadır."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Hibrit kaç greft verebilir?",
          "a": "Uygun bir donör alanda tek seansta genellikle 4.000–6.000; yalnız FUE ile yaklaşık 2.500–3.500. Kesin sayı vaat edilmez, ölçülür."
        },
        {
          "q": "İz belli olur mu?",
          "a": "Normal saç uzunluğunda genellikle hayır. Kazınmış kafada veya çok kısa kesimde soluk bir çizgi olarak görünür; bu, randevu almadan önce kabullenilmelidir."
        },
        {
          "q": "FUE'den daha mı ağrılı?",
          "a": "Kapatma nedeniyle ilk iki gece daha gergindir. Sonrasında iki taraf benzer hissedilir; şerit bölgesi sıklıkla morarmış bir ağrı olarak tarif edilir."
        },
        {
          "q": "Sonradan FUE yaptırabilir miyim?",
          "a": "Alım bölgeleri tüketilmediyse evet. Planın donör alanı bir kerede harcamak yerine gelecek seanslara bütçelemesinin nedeni tam olarak budur."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "İki donör bölgeyi de ölçer ve hibritin tek tekniğe göre bir şey katıp katmadığını size söyleriz.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk ve greft sayıları muayeneden sonra belirlenir; sonuçlar değişir.",
    "seoTitle": "Hibrit Saç Ekimi (FUE + FUT) İstanbul | Platinya",
    "seoDesc": "İstanbul'da hibrit saç ekimi: FUT şeridi ve FUE alımını tek seansta birleştirme, greft sayıları, iz ve iyileşme. Ücretsiz değerlendirme."
  },
  "/hair-transplant-for-women": {
    "title": "İstanbul'da Kadınlarda Saç Ekimi",
    "eyebrow": "Saç restorasyonu",
    "lead": "Kadınlarda saç kaybı genellikle kel bir alan değil, yaygın seyrelmedir ve çoğu zaman tedavi edilebilir bir nedeni vardır. Ekim, bu nedenler dışlandıktan sonra düşünülür — ve erkek ameliyatından farklı işler.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te kadınlarda saç kaybı ön görüşmesi",
    "stats": [
      {
        "value": "1 gün",
        "label": "Klinikte"
      },
      {
        "value": "Tıraş yok",
        "label": "Çoğu olguda"
      },
      {
        "value": "12 ay",
        "label": "Yoğunluğu değerlendirme"
      }
    ],
    "candidate": {
      "heading": "Kime yardımcı olur — kime olmaz",
      "intro": "Kadınlarda ilk soru «kaç greft» değil, «saç neden seyreliyor» sorusudur. Herhangi bir cerrahi plandan önce kan tetkikleri gelir.",
      "items": [
        "Demir, tiroid, D vitamini ve hormon sonuçları normal olmasına rağmen süren seyrelme",
        "Ayrım çizgisinde, şakaklarda veya ön saç çizgisi boyunca yerel seyrelme",
        "Traksiyon, yanık, ameliyat veya bir yıldır sabit kalmış alopesiden kaynaklanan izler",
        "Aşırı alma veya kalıcı makyaj travması sonrası kaş ya da saç çizgisi kaybı"
      ],
      "note": "Tüm saç derisinde yaygın dökülme — telogen effluvium — genellikle geri dönüşlüdür ve cerrahiyle tedavi edilmez. Önce demir eksikliği, tiroid hastalığı, PKOS ve doğum sonrası dökülme araştırılır; çünkü aktif dökülme sırasında ekim greft israfıdır."
    },
    "techniques": {
      "heading": "Kadın ameliyatı nasıl farklılaşır",
      "intro": "İlke aynı, uygulama değil: daha az tıraş, daha az greft, saçın nasıl döküldüğüne daha fazla özen.",
      "items": [
        {
          "name": "Kısmi tıraş veya hiç",
          "text": "Foliküller, çevredeki saçın örttüğü dar bir banttan alınabilir; böylece donör alanın kazınması gerekmez. Daha yavaş olduğu için seanslar daha küçüktür."
        },
        {
          "name": "Kapsama değil yoğunluk",
          "text": "Kadınlarda kayıp, saç çizgisini yeniden kurmak değil mevcut kılların arasına yoğunluk eklemektir. Greftler doğal dökülme yönünü izleyen bir açıyla, kendi foliküllerinizin arasına yerleştirilir."
        },
        {
          "name": "Tıbbi tedaviyle birlikte",
          "text": "Minoksidil ve bazı olgularda reçeteli ilaçlar genellikle ameliyat öncesi ve sonrasında sürdürülür — ekim yoğunluk ekler, altta yatan süreci durdurmaz."
        }
      ]
    },
    "journey": {
      "heading": "İlk görüşmeden itibaren",
      "steps": [
        {
          "name": "Önce nedenler",
          "text": "Kan testleri, dökülme öyküsü ve trikoskopi muayenesi. Geri dönüşlü bir neden bulunursa, ameliyat yeniden konuşulmadan önce o tedavi edilir."
        },
        {
          "name": "Yoğunluğun planlanması",
          "text": "Alan haritalanır ve greft sayıları bilinçli olarak ölçülü tutulur — seyrelen kadın saç derisinde aşırı yoğun yerleştirme, hâlâ orada olan saça zarar verebilir."
        },
        {
          "name": "Ameliyat günü",
          "text": "Lokal anestezi; seans genellikle dört–altı saat sürer. Hastaların çoğu aynı gün eve döner."
        },
        {
          "name": "İlk ay",
          "text": "Şişlik ve hassasiyet günler içinde geçer. Ekilen saç üçüncü haftadan itibaren dökülür — bu beklenen bir durumdur."
        },
        {
          "name": "6.–12. ay",
          "text": "Yoğunluk kademeli olarak artar. Saç rengi ve dokusu olgunlaştıkça çevredeki saçla uyum sağlar."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Riskler standart olanlar; kadınlarda daha çok önem taşıyan ikisi ayrıca var.",
      "items": [
        "İlk haftalarda greftlerin çevresindeki saçta şok dökülme — genellikle geçici ama korkutucu",
        "Seyrelen saç derisinde aşırı yoğun yerleştirmenin kendi foliküllerinize zarar vermesi",
        "Ameliyat sırasında altta yatan neden hâlâ aktifse düzensiz sonuç",
        "Folikülit, kabuklanma ve geçici uyuşma",
        "Hastaların az bir kısmında ekilen bölgede saç dokusunda görünür değişim"
      ],
      "note": "Demir, tiroid ve hormonları sormadan ameliyat öneren her klinik, ameliyatın buna değip değmediğine karar veren kısmı atlıyordur."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Kafamı kazıtmam gerekecek mi?",
          "a": "Genellikle hayır. Çoğu kadın seansında çevredeki saçın örttüğü kısmen kazınmış bir donör bandı kullanılır; ya da daha yavaş bir alımla hiç tıraş yapılmaz."
        },
        {
          "q": "Sonrasında saçımı her zamanki gibi kullanabilir miyim?",
          "a": "Yaklaşık on gün sonra, nazikçe evet. Boya ve perm altı–sekiz hafta bekler; ilk ay sıkı at kuyruğu ve örgüden kaçınılır."
        },
        {
          "q": "Bir seans yeterli mi?",
          "a": "Yaygın seyrelmede sıklıkla on iki ay arayla iki seans planlanır; çünkü yoğunluğu kademeli eklemek mevcut saçı korur."
        },
        {
          "q": "Neden hormonal ise ne olur?",
          "a": "O zaman hormonal tedavi temeldir ve cerrahi yalnızca ek bir adımdır. Kayıp aktifken ameliyat etmek, greftlerin çevresinde seyrelen bir sonuç verir."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Ayrım çizgisi, saç çizgisi ve donör alan fotoğrafları ile varsa son kan sonuçları ilk görüş için yeterli — cerrahinin doğru cevap olup olmadığı dahil.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Kadınlarda saç kaybı herhangi bir cerrahi plandan önce tanı gerektirir; sonuçlar değişir.",
    "seoTitle": "Kadınlarda Saç Ekimi İstanbul | Platinya Clinic",
    "seoDesc": "İstanbul'da kadınlarda saç ekimi: nedenlerin araştırılması, tıraşsız teknik, yoğunluk planı, iyileşme ve riskler. Ücretsiz değerlendirme."
  },
  "/eyebrow-transplant": {
    "title": "İstanbul'da Kaş Ekimi",
    "eyebrow": "Saç restorasyonu",
    "lead": "Saç derisinden tek tek kıllar alınır ve her kılın çıkış açısına uygun biçimde kaşa yerleştirilir; böylece aşırı alma, iz veya genetik nedeniyle seyrelmiş bir kaş yeniden oluşturulur.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te kaş ekimi ön görüşmesi",
    "stats": [
      {
        "value": "3–4 saat",
        "label": "İşlem süresi"
      },
      {
        "value": "200–400",
        "label": "Kaş başına greft"
      },
      {
        "value": "6–9 ay",
        "label": "Nihai şekil"
      }
    ],
    "candidate": {
      "heading": "Kimler için uygun",
      "intro": "Kaş, yüzdeki en görünür ekimdir; bu yüzden ilk iş, yeniden oluşturulacak bir şeklin hâlâ olup olmadığına karar vermektir.",
      "items": [
        "Yıllarca aşırı alma sonucu foliküllerin kendini toparlamadığı seyrelme",
        "Yanık, kesi veya kalıcı makyaj silinmesinden kalan izler",
        "Doğuştan seyrek ya da asimetrik kaşlar; ya da kemoterapi sonrası düzelmeyen kayıp",
        "Kaş bölgesinde aktif egzama, sedef veya enfeksiyon olmayan sağlıklı deri"
      ],
      "note": "Kaş, tiroid hastalığı veya beslenme eksikliği nedeniyle seyrelmişse önce onlar tedavi edilir. Saç derisinden alınan kıl, saç gibi uzamaya devam eder; yani kesilmesi gerekir — bu kalıcı bir bakımdır ve randevu almadan önce bunun anlaşılması gerekir."
    },
    "techniques": {
      "heading": "Nasıl yapılır",
      "intro": "Hacim değil hassasiyet: birkaç yüz tek kıl, her biri kendi açısına göre yerleştirilir.",
      "items": [
        {
          "name": "Tekli kıl greftleri",
          "text": "Yalnızca tek ve iki kıllı foliküler üniteler kullanılır. Çoklu greftler kaşta küme gibi görünür; bu yüzden verici alan ince, tekli kıllar için seçilir — çoğu zaman kulak arkasından."
        },
        {
          "name": "Açı ve yön",
          "text": "Kaş kılları kaşın başında yukarı ve dışa doğru çıkar, kuyruğa doğru yatıklaşır. Her greft bu deseni izleyecek şekilde tek tek yerleştirilir; aksi hâlde sonuç yapay durur."
        },
        {
          "name": "İki seansta yoğunluk",
          "text": "Temkinli bir ilk seans, ince kaş derisinin kan akımını korur; 9–12 ay sonra yapılan ikinci seans, başta aşırı sıkıştırmak yerine ihtiyaç duyulan yere yoğunluk ekler."
        }
      ]
    },
    "journey": {
      "heading": "Tasarımdan nihai şekle",
      "steps": [
        {
          "name": "Yüz üzerinde tasarım",
          "text": "Kaş, siz otururken çizilir; diğer tarafla ve yüz oranlarıyla karşılaştırılır ve herhangi bir greft alınmadan önce üzerinde anlaşılır."
        },
        {
          "name": "Ameliyat",
          "text": "Lokal anestezi. Verici alandan alım, ardından ince iğnelerle yerleştirme. İki kaş için üç–dört saat."
        },
        {
          "name": "İlk on gün",
          "text": "Küçük kabuklar; bölgeye makyaj yok, ovmamak ve yüzüstü yatmamak gerekir. Şişlik bir haftada iner."
        },
        {
          "name": "3.–8. haftalar",
          "text": "Greftlerin çoğu dökülür, bu normaldir. Kaş bir süre ameliyat gününden daha seyrek görünür."
        },
        {
          "name": "6.–9. ay",
          "text": "Yeni kaş kılı yerleşir. Bundan sonra uzun uzar ve birkaç haftada bir küçük makasla kesilir."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Yüzde küçük teknik hatalar görünür olur. Konuşulması gerekenler bunlar.",
      "items": [
        "Doğal olmayan yön veya eklenti gibi görünen aşırı yoğun bölge",
        "İki kaş arasında asimetri — kusursuz simetri mümkün değildir",
        "Kan akımının daha zayıf olduğu izli deride greft kaybı",
        "İlk haftalarda folikülit veya küçük kistler",
        "Orijinal kaştan daha hızlı ve daha uzun uzayan, düzenli kesim gerektiren kıl"
      ],
      "note": "Ameliyattan bir gün sonrasını değil, altı ay ve üzeri iyileşmiş sonuçları görmek isteyin. Yön ve yoğunluk ancak kıllar oturduktan sonra görünür hâle gelir."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Doğal görünür mü?",
          "a": "Tekli kıllar kullanıldığında ve doğru açıyla yerleştirildiğinde evet — konuşma mesafesinde normal bir kaş gibi okunur. Risk aşırı yoğunluktur; ilk seansın temkinli olmasının nedeni budur."
        },
        {
          "q": "Hâlâ şekil verebilir miyim?",
          "a": "Evet, ama dikkatle. Cımbız ve ağda kullanılmaz; ekilmiş kaşlar makasla kesilerek bakılır."
        },
        {
          "q": "Ne zaman makyaj yapabilirim?",
          "a": "Yaklaşık 7–10 gün sonra, kabuklar gidip deri kapandığında."
        },
        {
          "q": "İkinci seans gerekir mi?",
          "a": "Yoğunluk için çoğu zaman evet; 9–12 ay sonra planlanır. İlk seans şekli kurmak, ikincisi onu doldurmak için tasarlanır."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Her kaşın yakın plan fotoğrafı, önden ve açılı olarak, nelerin yeniden oluşturulabileceğini değerlendirmek için yeterli.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Kaş uygunluğu yüz yüze değerlendirilir; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "İstanbul'da Kaş Ekimi | Platinya Clinic",
    "seoDesc": "İstanbul'da kaş ekimi: tekli greftler, doğal açı ve yön, iyileşme süreci ve riskler. Platinya Clinic'te ücretsiz ön değerlendirme."
  },
  "/hollywood-smile": {
    "title": "İstanbul'da Hollywood Gülüşü",
    "eyebrow": "Diş tedavileri",
    "lead": "Hollywood Gülüşü tek bir işlem değil bir plandır: ön dişlerin şekli, rengi ve oranları birlikte tasarlanır, sonra veneer, kuron ve — diş eti hattı düzensizse — diş eti şekillendirme ile uygulanır. Planların çoğu beş–yedi günde tamamlanır.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te Hollywood Gülüşü ön görüşmesi",
    "stats": [
      {
        "value": "5–7 gün",
        "label": "Tipik plan"
      },
      {
        "value": "8–20",
        "label": "Genellikle kapsanan diş"
      },
      {
        "value": "10–15 yıl",
        "label": "Bakımla kullanım ömrü"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Tasarım yüze ve kapanışa uymak zorundadır. Fotoğrafta doğru görünen bir gülüş, dişlerini sıkan ya da diş eti çok görünen biri için yanlış olabilir.",
      "items": [
        "Kırılmış, kenarları aşınmış veya beyazlatmayla değişmeyecek şekilde renklenmiş ön dişler",
        "Küçük aralıklar ya da ortodonti gerektirmeyecek kadar dönmüş veya hafif çapraşık dişler",
        "Yanındaki dişlerle artık uyuşmayan eski kuronlar veya büyük ön dolgular",
        "Bazı dişlerin diğerlerinden uzun göründüğü düzensiz diş eti hattı"
      ],
      "note": "Önce dişlerin ve diş etlerinin sağlıklı olması gerekir. Aktif çürük, diş eti hastalığı veya dengesiz kapanış herhangi bir veneer yapılmadan önce tedavi edilir; aksi hâlde yeni iş, hâlâ hareket eden bir şeyin üzerine kurulur."
    },
    "techniques": {
      "heading": "Gülüş nasıl inşa edilir",
      "intro": "Karışım; ne kadar diş kaldığına, ne kadar minenin korunabileceğine ve gerçekte ne kadar değişim istediğinize göre belirlenir.",
      "items": [
        {
          "name": "Dijital tasarım ve deneme gülüşü",
          "text": "Fotoğraflar ve ağız içi tarama ile gülüş ekranda tasarlanır; oranlar şablondan değil yüzünüzden alınır. Tasarım bir mock-up olarak basılır ve kendi dişlerinizin üzerine geçici olarak yapıştırılır; böylece kalıcı bir işlem yapılmadan önce görür, onunla konuşur ve değiştirebilirsiniz."
        },
        {
          "name": "Veneer ve kuronlar",
          "text": "Veneer, sağlam dişlerin ön yüzüne yapıştırılan ince seramik kaplamalardır ve çok az preparasyon ya da hiç preparasyon gerektirmez. Kuronlar dişin tamamını kaplar; yoğun dolgulu, kanal tedavili veya büyük ölçüde kaybolmuş dişlerde kullanılır. Çoğu gülüş tasarımı ikisini karıştırır: ortada veneer, destek gereken dişte kuron."
        },
        {
          "name": "Diş eti şekillendirme",
          "text": "Düzensiz diş eti hattı lazer veya ince bir bistüriyle yeniden şekillendirilir. Diş eti ve kemik düşük olduğu için dişlerin kendisi kısaysa kuron uzatma gerekir — plana gün değil hafta ekleyen küçük bir cerrahi adım."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden nihai gülüşe",
      "steps": [
        {
          "name": "Değerlendirme ve tasarım",
          "text": "Muayene, röntgenler, fotoğraflar ve renk kaydı. Kapanış, aşınma ve sıkma açısından kontrol edilir. Tasarım size sınırlarıyla gösterilir: hangi dişler, ne kadar mine ve cildinize göre ne kadar beyazlığın inandırıcı olduğu."
        },
        {
          "name": "Deneme gülüşü",
          "text": "Bir mock-up bir–iki gün için dişlerin üzerine yapıştırılır. Eleştirel olmanın tam zamanı budur — uzunluk, simetri, konuşurken nasıl göründüğü — çünkü hâlâ geri alınabilir."
        },
        {
          "name": "Preparasyon",
          "text": "Lokal anestezi altında mine, seramiğin ekleyeceği kalınlık kadar azaltılır, ölçü veya tarama alınır ve geçici restorasyonlar aynı gün takılır. Dişler genellikle birkaç gün hassas olur."
        },
        {
          "name": "Prova",
          "text": "Seramik laboratuvardan döner ve simanlanmadan önce uyum, renk ve kapanış açısından kuru olarak kontrol edilir. Bu aşamada küçük düzeltmeler normaldir; yeniden üretim gün ekler."
        },
        {
          "name": "Takma ve kontrol",
          "text": "Restorasyonlar yapıştırılır, kapanış düzenlenir ve diş sıkıyorsanız gece plağı yapılır. Bir–iki hafta içinde kontrol, ardından rutin temizlik — bu restorasyonların ömrü kenarlarda belirlenir."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Bu tek bir ameliyat değil, bir dizi kalıcı karardır. İlk diş hazırlanmadan önce bilinmesi gerekenler bunlar.",
      "items": [
        "Veneer için alınan mine geri gelmez; o dişler her zaman bir restorasyon gerektirecek",
        "Günlerce veya haftalarca, bazen daha uzun süren sıcak-soğuk hassasiyeti",
        "Kırılma veya ayrılma; en sık diş sıkanlarda ve tırnak yiyenlerde",
        "Özellikle çok sayıda diş aynı anda yapıldığında fazla opak veya fazla tekdüze görünen renk",
        "Temizliğin zorlaştığı kenarlarda diş eti iltihabı veya çekilmesi"
      ],
      "note": "Asıl hayal kırıklığı genellikle seramik değil plandır — çok fazla diş, çok beyaz bir renk ya da dengesiz bırakılmış bir kapanış, ön dişlerin hiç tasarlanmadıkları yükü taşımasına yol açar."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ne kadar sürer?",
          "a": "Basit bir olguda klinikte beş–yedi gün: preparasyon ve takma için iki ziyaret, arada laboratuvar çalışır. Diş eti cerrahisi, kapanış restorasyonu veya çekim gerekiyorsa plan haftalara ya da aylara yayılır."
        },
        {
          "q": "Doğal görünür mü?",
          "a": "Görünebilir, ancak doğallık varsayılan değil bir karardır. Gerçek dişler tek bir düz renk değildir: boyun kısmı daha sıcak, kenar daha yarı saydam, yüzey dokuludur. İyi bir seramik sanatçısı bunu yeniden üretir; çok beyaz ve çok opak bir set, hangi seramik kullanılırsa kullanılsın yapay durur."
        },
        {
          "q": "Tüm dişlerimin yapılması gerekir mi?",
          "a": "Genellikle üst çenede sekiz–on diş; gülerken ve konuşurken görünen dişler bunlardır. Alt dişler görünmüyorsa çoğu zaman dokunulmaz. Görünenden fazlasını yapmak, gülüşü değiştirmeden maliyet ve mine kaybı ekler."
        },
        {
          "q": "Ne kadar dayanırlar?",
          "a": "İyi yapılmış veneerler genellikle on–on beş yıl dayanır; kuronlar benzer veya daha uzun. Kullanım ömrünü seramikten çok kapanış, sıkma ve kenarların ne kadar dikkatli temizlendiği belirler."
        }
      ]
    },
    "ctaBand": {
      "heading": "Gülüşünüzün fotoğraflarını gönderin",
      "text": "Bir ön görünüm, dişlerin yakın çekimi ve dudaklar dinlenirken bir fotoğraf; nelerin mümkün olduğu, kaç dişi kapsayacağı ve ne gerektireceği konusunda ilk görüş için yeterli.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk ancak dişler, diş etleri, kapanış ve tıbbi geçmiş incelendikten sonra belirlenebilir; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "Hollywood Gülüşü İstanbul | Platinya Clinic",
    "seoDesc": "İstanbul'da Hollywood Gülüşü: dijital tasarım, veneer ve kuron, diş eti şekillendirme, süre ve riskler. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/dental-veneers": {
    "title": "İstanbul'da Porselen Kaplama (E-max) Diş",
    "eyebrow": "Diş tedavileri",
    "lead": "Veneer, dişin ön yüzüne yapıştırılan ince bir seramik kaplamadır. Amaç, mümkün olduğunca az mine alarak şekli ve rengi değiştirmektir — minimal hazırlıkta bu yaklaşık 0,3–0,8 mm'dir ve geri gelmez.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te porselen veneer ön görüşmesi",
    "stats": [
      {
        "value": "2 randevu",
        "label": "Klinikte"
      },
      {
        "value": "0,3–0,8 mm",
        "label": "Genellikle alınan mine"
      },
      {
        "value": "10 yıl+",
        "label": "Tipik kullanım ömrü"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Veneerler ön dişlerde şekil, renk ve konum sorunlarını çözer. Kapanış sorununu çözmez ve çapraşık dişleri ortodonti kadar iyi düzeltmez.",
      "items": [
        "Kırılmış, aşınmış veya hafif dönmüş ön dişler; istenen değişiklik estetikse",
        "Dişin içinden gelen renk değişimi — florozis, eski tetrasiklin lekelenmesi, kanal tedavili diş — beyazlatmanın açamadığı durumlar",
        "Küçük aralıklar ve düzensiz kenarlar; tek bir orta hat aralığı çoğu zaman kapatılabilir",
        "Sağlam mine: veneerin yapışacağı sağlıklı bir doku gerekir"
      ],
      "note": "Çapraşıklık belirginse genellikle önce ortodonti daha doğru plandır: daha az diş kesilir ve sonuç daha uzun dayanır. Çapraşık dişlerin üzerine yapılan veneerler kalın, opak ve temizlenmesi zor olur."
    },
    "techniques": {
      "heading": "Hangi seramik, neden",
      "intro": "Malzeme; ne kadar diş eksik olduğuna, ne kadar minenin korunabileceğine ve işin tek diş mi tam gülüş mü olduğuna göre seçilir.",
      "items": [
        {
          "name": "E-max — lityum disilikat",
          "text": "Çoğu veneer için standart seçim: preslenmiş veya frezelenmiş lityum disilikat, rezin simanla yapıştırılır. Ön dişler ve küçük azılar için yeterince güçlü, mine gibi davranacak kadar yarı saydam ve tam kuron yerine yaklaşık 0,3–0,8 mm preparasyon ister."
        },
        {
          "name": "Feldspatik seramik",
          "text": "Freze yerine seramik sanatçısı tarafından katman katman işlenir; renk ve yarı saydamlık katmanlarla oluşturulur. Tek ve görünür bir diş için en doğal seçenek; aynı zamanda daha ince, tekniğe daha duyarlı ve daha pahalıdır."
        },
        {
          "name": "Kompozit bonding",
          "text": "Doğrudan dişin üzerine işlenen rezin; mine alınmaz, tek randevuda biter ve geri alınabilir. Daha çabuk lekelenir ve kırılır — beş–yedi yıl gerçekçidir — bu yüzden küçük onarımlar veya seramiğe karar vermeden önce şekli denemek için uygundur."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden yapıştırılmış veneerlere",
      "steps": [
        {
          "name": "Değerlendirme",
          "text": "Fotoğraflar, röntgenler, renk ve kapanış. İlk soru ortodontinin daha iyi sonuç verip vermeyeceği, ikincisi çalışılacak ne kadar mine olduğudur."
        },
        {
          "name": "Hazırlık",
          "text": "Lokal anestezi altında mine, planlanan seramiğin kalınlığı kadar azaltılır, tarama alınır ve dişler açık ya da hassas kalmasın diye geçici veneerler takılır."
        },
        {
          "name": "Prova",
          "text": "Seramik, hiçbir şey yapıştırılmadan önce suda çözünen bir patla prova edilir. Uyum, renk ve şekil yalnızca ameliyathane ışığında değil, gün ışığında da kontrol edilir."
        },
        {
          "name": "Yapıştırma",
          "text": "Rubber dam altında mine asitlenir, veneer rezin simanla yapıştırılır, kenarlardaki fazlalık temizlenir ve kapanış düzenlenir. Bu aşama geri alınamaz."
        },
        {
          "name": "Kontrol ve bakım",
          "text": "Bir–iki hafta içinde kontrol, diş sıkıyorsanız gece plağı ve kenarlarda diş ipi kullanımını içeren temizlik talimatları. Veneerleri kıran şey tırnaklar, buz ve kalem kapaklarıdır."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "İşlem küçüktür ama değişim kalıcıdır. İlk diş hazırlanmadan önce anlaşılması gereken sınırlar bunlar.",
      "items": [
        "Mine kaybı kalıcıdır: diş her zaman bir veneer, kuron veya kompozit gerektirecek",
        "Soğuğa hassasiyet, bazen haftalarca; özellikle ince preparasyonlarda",
        "Ayrılma veya kırılma, genellikle onarılabilir — ancak kompozit onarım hiçbir zaman tam eşleşmez",
        "Tek bir veneeri, komşu dişler yıllar sonra yaşlandığında veya renk değiştirdiğinde eşleştirmek zordur",
        "Kenarda diş eti çekilmesi ve veneer kenarının açığa çıkması; preparasyon çok agresifse pulpa iltihabı"
      ],
      "note": "Koruyucu preparasyonun en güçlü gerekçesi ilk beş yıl değil, üçüncü yenilemedir: her yenileme biraz daha diş alır ve alınabilecek miktarın bir tabanı vardır."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ne kadar diş alınıyor?",
          "a": "Tipik bir E-max veneerde 0,3–0,8 mm, diş zaten aşınmışsa bazen hiç. Miktar, seramiğin güçlü olması için gereken kalınlığa ve dişin görsel olarak ne kadar kaydırılması gerektiğine göre belirlenir."
        },
        {
          "q": "Veneerler lekelenir mi?",
          "a": "Seramiğin kendisi rezin gibi renk emmez. Değişen şey kenardır: dişle birleşim yeri açığa çıkarsa veya iyi temizlenmezse koyulaşır. Rutin kontrollerde yapılan polisaj temiz görünmesini sağlar."
        },
        {
          "q": "Kalın görünürler mi?",
          "a": "Yalnızca fazla hacim eklenirse. Veneer bir dişi uzatabilir veya genişletebilir, ama dişin hâlihazırda olduğundan daha ince yapamaz; bu yüzden öne çıkan bir diş daha fazla seramik değil preparasyon gerektirir. Bu, yapıştırmadan sonra değil tasarım aşamasında netleşir."
        },
        {
          "q": "Ne kadar dayanırlar?",
          "a": "İyi yapılmış ve iyi bakılmış veneerlerde on yıl ve çoğu zaman daha fazla. Başarısızlıklar genellikle kesici kenarda kırılma veya kenarda sızıntıdır ve ikisi de gece plağı kullanmayan diş sıkıcılarda daha sıktır."
        }
      ]
    },
    "ctaBand": {
      "heading": "Değiştirmek istediğiniz dişin fotoğrafını gönderin",
      "text": "Yakın ve net bir fotoğraf ile bir ön görünüm, veneer, bonding veya ortodontiden hangisinin daha mantıklı olduğunu ve preparasyonun size ne kadar mineye mal olacağını söylemek için yeterli.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk ancak dişler, diş etleri, kapanış ve tıbbi geçmiş incelendikten sonra belirlenebilir; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "Porselen Diş Kaplama (E-max) İstanbul | Platinya",
    "seoDesc": "İstanbul'da porselen diş kaplama: E-max veneer, feldspatik seramik ve bonding seçenekleri, mine kaybı ve bakım. Ücretsiz değerlendirme."
  },
  "/teeth-whitening": {
    "title": "İstanbul'da Diş Beyazlatma",
    "eyebrow": "Diş tedavileri",
    "lead": "Beyazlatma, doğal dişlerin rengini peroksitle değiştirir — koltukta kontrollü bir konsantrasyonla ya da evde kişiye özel plakla iki–dört hafta boyunca. Kuron, veneer veya dolguların rengini değiştirmez ve planın tamamını bu sınır şekillendirir.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te diş beyazlatma değerlendirmesi",
    "stats": [
      {
        "value": "45–90 dk",
        "label": "Klinik seansı"
      },
      {
        "value": "1–2 seans",
        "label": "Genellikle yeterli"
      },
      {
        "value": "6–24 ay",
        "label": "Rötuşa kadar"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Sağlıklı yetişkin dişlerinin çoğu bir ölçüde yanıt verir. Değişen; lekenin türü, başlangıç rengi ve rengin minede mi yoksa dişin daha derininde mi olduğudur.",
      "items": [
        "Genellikle yaşa bağlı ya da çay, kahve ve tütünden kaynaklanan sarı veya grimsi doğal dişler",
        "Profesyonel temizlik ve polisajdan kısa süre sonra geri gelen lekelenme",
        "Veneer veya kuron öncesi; böylece seramik, tersi yerine daha açık bir tona göre eşleştirilebilir",
        "Sağlıklı diş etleri ve tedavi edilmemiş çürük olmaması: sızdıran bir dolgunun veya açık dentinin üzerine beyazlatma, beyazlık değil ağrı verir"
      ],
      "note": "Kuronlar, veneerler, kompozit dolgular ve bonding açılmaz. Görünür restorasyonları olan bir ağzı beyazlatmak, onları kontrast nedeniyle daha koyu gösterebilir; ya sonradan değiştirilirler ya da renk onlara göre eşleştirilir."
    },
    "techniques": {
      "heading": "Koltukta, evde veya ikisi",
      "intro": "İki yaklaşım aynı kimyayı farklı konsantrasyonlarda kullanır. Hangisinin size uyduğu, ne kadar zamanınız olduğuna ve dişlerinizin nasıl tepki verdiğine bağlıdır.",
      "items": [
        {
          "name": "Klinikte beyazlatma",
          "text": "Yüksek konsantrasyonlu hidrojen peroksit jeli — tipik olarak %25–40 — diş etleri izole edilip dudaklar çekilerek, 10–15 dakikalık üç veya dört döngü hâlinde uygulanır. Tek ziyaret, en hızlı sonuç; hassasiyet genellikle ertesi gün zirve yapar."
        },
        {
          "name": "Evde kişiye özel plakla beyazlatma",
          "text": "Ölçü alınır ve plağa uygun plaklar yapılır. %10–16 karbamid peroksit günde 30–60 dakika ya da daha zayıf bir jel gece boyunca, iki–dört hafta uygulanır. Daha yavaş ve daha nazik; sonuç genellikle daha eşit olur çünkü jel tüm arkı dolaşır."
        },
        {
          "name": "Kombine",
          "text": "Ana tonu açmak için bir koltuk seansı, ardından dişin genellikle en koyu kısmı olan boyun bölgesini eşitlemek için bir–iki hafta evde plak. Hastaların çoğunun vardığı plan budur."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden nihai tona",
      "steps": [
        {
          "name": "Değerlendirme ve temizlik",
          "text": "Çürük, diş eti sağlığı ve mevcut restorasyonlar kontrol edilir. Önce diş taşı temizliği ve polisaj gelir: beyazlatma diş taşını almaz ve temiz bir yüzey tek adil başlangıç noktasıdır."
        },
        {
          "name": "Renk kaydı",
          "text": "Herhangi bir işlem başlamadan önce standart ışık altında fotoğraflar ve renk okuması. Bu olmadan değişim ölçülemez, yalnızca tartışılabilir."
        },
        {
          "name": "Beyazlatma",
          "text": "Ya diş eti izolasyonuyla tek bir koltuk seansı ya da plaklar ve yazılı talimatlar. Plaklarda ilk iki–üç gün dişlerinizin hassas olup olmadığını gösterir ve jel gücü buna göre ayarlanır."
        },
        {
          "name": "İki hafta sonra kontrol",
          "text": "Dişler yeniden su aldıkça renk yaklaşık iki haftada stabilize olur; nihai ton o zaman değerlendirilir — tedavi gününde değil, çünkü o gün dişler her zaman doğal olmayan biçimde parlak görünür."
        },
        {
          "name": "İdame",
          "text": "Altı–yirmi dört ayda bir rötuş plakları ve akıllıca geçirilen ilk 48 saat: mine en alıcı durumdayken kahve, kırmızı şarap, zerdeçal ve sigara yok."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Beyazlatma, değerlendirilip gözetim altında yapıldığında düşük risklidir. Sorunların çoğu ikisi de olmadan yapılmasından kaynaklanır.",
      "items": [
        "Tedavi sırasında ve sonrasında bir–iki gün, bazen daha uzun süren hassasiyet; mevcut diş eti çekilmesi bunu kötüleştirir",
        "Jelin yumuşak dokuya ulaştığı yerde diş eti tahrişi veya soluklaşması — genellikle geçici ve günler içinde düzelir",
        "İç kaynaklı lekelerde, kanal tedavili dişte veya floroziste az ya da hiç değişim olmaması",
        "Restorasyonlar özgün tonunu korur ve çevrelerindeki dişler açıldığında daha koyu görünebilir",
        "Geri dönüş: sonuç kalıcı değildir ve ne kadar hızlı solacağı beslenmeye ve sigaraya bağlıdır"
      ],
      "note": "Daha fazla jel daha beyaz demek değildir. Kontrolsüz tekrarlanan yüksek güçlü seanslar hassasiyeti artırır ve mineye tebeşirimsi, ince bir görünüm verir; plak talimatları boşuna yoktur."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Mineye zarar verir mi?",
          "a": "Gözetimli konsantrasyonlarda hayır: peroksit, ölçülebilir diş dokusunu çözmeden pigmenti kaldırır ve mineral sonraki günlerde yerine gelir. Hasar ve kalıcı hassasiyet, değerlendirme yapılmadan sık sık yüksek güçlü seans yapılmasından kaynaklanır."
        },
        {
          "q": "Dişlerim ne kadar beyaz olur?",
          "a": "Önceden garanti edilemez. Sarı ve yaşa bağlı lekelenme en iyi yanıt verir; gri, tetrasiklin kaynaklı ve florozis lekelenmesi zayıf yanıt verir, bazen hiç vermez. Hastaların çoğu birkaç ton açılır ve dürüst cevap bir sayı değil bir aralıktır."
        },
        {
          "q": "Ağrılı mı?",
          "a": "Jelin kendisi ağrılı değildir. Soğuğa hassasiyet ve bazen dişin boyun kısmında keskin bir sızı bir–iki gün sık görülür — daha düşük konsantrasyon, daha kısa uygulama süresi veya seanstan önce hassasiyet giderici jel ile azalır."
        },
        {
          "q": "Ne kadar kalıcı?",
          "a": "Çoğu kişide altı ay ile iki yıl. Kahve, çay, kırmızı şarap, zerdeçal ve sigara geri gelmesini hızlandırır; altı ayda bir hijyen ziyareti ve ara sıra rötuş plağı sonucu sabit tutar."
        }
      ]
    },
    "ctaBand": {
      "heading": "Gün ışığında bir fotoğraf gönderin",
      "text": "Pencere kenarında, filtresiz çekilmiş bir fotoğraf genellikle ne tür bir lekeniz olduğunu, beyazlatmanın işe yarayıp yarayacağını ve restorasyonların buna göre planlanması gerekip gerekmediğini söylemek için yeterli.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk ancak dişler ve diş etleri incelenip tıbbi geçmiş gözden geçirildikten sonra belirlenebilir; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "İstanbul'da Diş Beyazlatma | Platinya Clinic",
    "seoDesc": "İstanbul'da diş beyazlatma: klinikte ve evde plakla beyazlatma, hassasiyet, kalıcılık ve restorasyonlar. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/dental-implants": {
    "title": "İstanbul'da Diş İmplantı",
    "eyebrow": "Diş tedavileri",
    "lead": "İmplant, çene kemiğine yerleştirilen bir titanyum vidadır; üç–altı ay içinde kemik onun üzerine büyür ve ardından üzerine kuron, köprü veya tam ark sabitlenir. Kökün yerini aldığı için yanındaki dişlere bağlı değildir.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te diş implantı ön görüşmesi",
    "stats": [
      {
        "value": "3–6 ay",
        "label": "Kuron öncesi kemik iyileşmesi"
      },
      {
        "value": "45–90 dk",
        "label": "Tek implant yerleştirme"
      },
      {
        "value": "10–15 yıl+",
        "label": "Bakımla işlev süresi"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Belirleyici olan, ne kadar kemik olduğu, kalitesi, diş etlerinin durumu ve varsa genel hastalığın ne kadar kontrol altında olduğudur.",
      "items": [
        "Köprü için kesilmemesi gereken sağlıklı komşuları olan tek eksik diş",
        "Aynı arkus içinde birden fazla eksik diş, ya da gevşemiş veya artık kullanılamayan tam ark",
        "Yeterli kemik — veya greft ya da sinüs lifting ile yeniden oluşturulabilecek kemik",
        "Kontrol altında diyabet, sigara içmiyor olmak ya da bırakmaya istekli olmak; çeneye yakın zamanda radyoterapi veya antirezorptif tedavi almamış olmak"
      ],
      "note": "Sigara, değiştirilebilecek en faydalı tek şeydir: implantın kemiğe tutunma başarısızlığı riskini kabaca iki katına çıkarır ve etkisi içilen miktara bağlıdır. Kontrol altında olmayan diyabet de iyileşmeyi benzer şekilde etkiler."
    },
    "techniques": {
      "heading": "Tek diş, birkaç diş veya tam ark",
      "intro": "İmplantların sayısı ve konumu, kaç dişin eksik olduğuna göre değil; mevcut kemiğe ve kapanışın bu kemiği nasıl yüklediğine göre belirlenir.",
      "items": [
        {
          "name": "Tek implant ve kuron",
          "text": "Tek eksik diş için en koruyucu çözüm: komşu dişlerden hiçbir şey kesilmez. Yerleştirme lokal anestezi altında 45–90 dakika sürer, kuron yapılmadan önce üç–altı aylık iyileşme beklenir."
        },
        {
          "name": "İmplant destekli köprü",
          "text": "Ardışık birkaç eksik dişte, iki veya daha fazla implant bir köprü taşır; böylece iki uçtaki dişler dokunulmadan kalır. Değiştirilen diş sayısından az implant kullanılır — bu yüzden açıklık dikkatle planlanmalı, bir vida tasarrufu için uzatılmamalıdır."
        },
        {
          "name": "All-on-4 ve All-on-6",
          "text": "Dört veya altı implant üzerine sabitlenen tam ark; arka implantlar kalan kemiği kullanmak ve çoğu zaman greftten kaçınmak için açılı yerleştirilir. Genellikle birkaç gün içinde geçici köprü takılabilir; kalıcı köprü iyileşmeyi bekler. Herkes uygun değildir — kemik hacmi, kapanış ve dudak desteği kararı verir."
        }
      ]
    },
    "journey": {
      "heading": "Görüntülemeden kalıcı kurona",
      "steps": [
        {
          "name": "Değerlendirme ve planlama",
          "text": "CBCT, kemik yüksekliğini ve genişliğini ölçer, sinir ve sinüsün nerede olduğunu gösterir. Kemik inceyse önce greft veya sinüs lifting planlanır; bu, implant yerleştirmeden önce dört–altı ay ekler."
        },
        {
          "name": "Yerleştirme",
          "text": "Lokal anestezi altında, tek implant için 45–90 dakika. Stabilite kaydedilir; varsa geçici diş veya protez, iyileşme sırasında implantı yüklemeyecek şekilde uyarlanır."
        },
        {
          "name": "Osseoentegrasyon",
          "text": "İmplantın kendi hâline bırakıldığı üç–altı ay. Alt çene genellikle üst çeneden daha erken hazır olur, greftli bölgeler daha uzun sürer. Sigara ve iyi kontrol edilmeyen diyabet bu aşamayı yavaşlatır."
        },
        {
          "name": "Abutment ve ölçü",
          "text": "Diş eti iyileşme abutmenti çevresinde şekillendirilir, ardından tarama veya ölçü alınır ve kuron ya da köprü yapılır — laboratuvarda genellikle bir–üç hafta."
        },
        {
          "name": "Takma ve bakım",
          "text": "Restorasyon vidalanır veya yapıştırılır ve kapanış kontrol edilir. Altı ayda bir hijyen kontrolü; birinci yılda ve sonrasında düzenli aralıklarla röntgen: implant çevresindeki kemik kaybı, ilerleyene kadar sessizdir."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "İmplant cerrahisi rutindir ama sonuçta kemiğe yapılan bir ameliyattır ve başarısızlık biçimleri kendine özgüdür. Önemli olanlar bunlar.",
      "items": [
        "Kemiğe tutunamama: implant gevşer ve çıkarılması gerekir — sigara içenlerde, ince kemikte ve kontrolsüz diyabette daha olası",
        "Peri-implantitis, çalışan bir implantın çevresinde kemik kaybı; genellikle plağa bağlıdır ve kendiliğinden geri dönmez",
        "Alt çenede sinir zedelenmesi ve buna bağlı dudak, çene veya dilde uyuşma — genellikle geçici, bazen kalıcı",
        "Üst çenede sinüs perforasyonu veya greft başarısızlığı; ikinci bir işlem gerekebilir",
        "Parça kırılması, gevşeyen vida veya kırılan kuron — onarılabilir, ancak ücretsiz değil"
      ],
      "note": "İmplant bir diş değildir. Ligamenti yoktur, çok sert ısırdığınızda geri bildirimi azdır ve çevresinde kemik kaybı bir kez başladığında onu geri kazanmanın yolu yoktur. Hijyen ve gece plağı, kutunun üzerindeki markadan daha önemlidir."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ameliyat ağrılı mı?",
          "a": "Lokal anesteziyle ağrı değil basınç ve titreşim hissedersiniz. İlk iki gün hassasiyet ve şişlik olur; genellikle sıradan parasetamol veya ibuprofen yeterlidir ve çoğu kişi ertesi gün masa başı işine döner."
        },
        {
          "q": "Tüm süreç ne kadar sürüyor?",
          "a": "Tek implantta yerleştirmeden kalıcı kurona dört–sekiz ay, çünkü takvimi kemik belirler. All-on-4 ile tam arkte birkaç gün içinde sabit geçici protez olabilir; kalıcı köprü dört–altı ayda takılır."
        },
        {
          "q": "Sigara içebilir miyim?",
          "a": "Tedavi boyunca ideal olarak hiç içmemek gerekir. Yerleştirmeden en az bir hafta önce ve sonraki yaklaşık sekiz hafta boyunca bırakmak, tutunma şansını ölçülebilir biçimde artırır; sonrasında içmek implant çevresinde uzun vadeli kemik kaybı riskini yükseltir."
        },
        {
          "q": "Yeterli kemiğim yoksa ne olur?",
          "a": "Kemik eklenebilir — genişlik için membranla birlikte partikül greft, daha büyük defektler için blok greft, üst arka çene için sinüs lifting. Kendi iyileşme süresi olan ayrı bir işlemdir ve ameliyat sırasında keşfedilmez, görüntülemeden planlanır."
        }
      ]
    },
    "ctaBand": {
      "heading": "Panoramik röntgeninizi gönderin",
      "text": "Yakın tarihli bir panoramik röntgen veya CBCT ile hangi dişlerin eksik olduğu bilgisi, greft gerekip gerekmeyeceğini, kabaca kaç implant olacağını ve planın ne kadar süreceğini söylemek için yeterli.",
      "button": "Röntgeninizi gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk ancak ağız muayenesi, CBCT incelemesi ve tıbbi geçmiş değerlendirildikten sonra belirlenebilir; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "İstanbul'da Diş İmplantı | Platinya Clinic",
    "seoDesc": "İstanbul'da diş implantı: tek diş, köprü ve All-on-4/6 seçenekleri, kemik grefti, iyileşme süreci ve riskler. Ücretsiz değerlendirme."
  },
  "/zircon-teeth": {
    "title": "İstanbul'da Zirkonyum Kaplama Diş",
    "eyebrow": "Diş tedavileri",
    "lead": "Zirkonyum kuron, bir zirkonyum dioksit bloktan frezelenir ve sertleşene kadar sinterlenir. Metal-seramik kuronun diş etinde gri bir çizgi bırakacağı yerlerde kullanılır; hem ön hem de arka dişler için yeterince güçlüdür.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te zirkonyum kuron ön görüşmesi",
    "stats": [
      {
        "value": "2 randevu",
        "label": "Klinikte"
      },
      {
        "value": "5–7 gün",
        "label": "Laboratuvar süresi"
      },
      {
        "value": "10–15 yıl",
        "label": "Tipik kullanım ömrü"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Zirkonyum güç için, metalsiz estetik için ya da ikisi için seçilir. İyi yapılmış bir metal-seramik kurondan otomatik olarak daha iyi değildir — farklıdır.",
      "items": [
        "Tam kaplama gerektiren yoğun dolgulu, kanal tedavili veya çatlamış dişler",
        "İnce tam seramik kuronun kırılacağı, ağır yük altındaki arka dişler",
        "Diş eti hattının metalsiz kalması gereken görünür ön dişler",
        "Bilinen metal hassasiyeti ya da kenarı koyu görünen mevcut metal-seramik kuron"
      ],
      "note": "Bir kuronun tutunabilmesi için yeterli diş gerekir. Diş eti üzerinde çok az doku kaldıysa önce kor yapımı veya kuron uzatma gerekebilir; kuron, kaybedilen diş dokusunun yerini süresiz tutamaz."
    },
    "techniques": {
      "heading": "Monolitik veya katmanlı",
      "intro": "İkisi de zirkonyum. Fark, kuronun tamamının aynı malzeme olması ya da güçlü bir kor üzerine porselen kaplanmasıdır; görünümü ve başarısızlık biçimini de bu belirler.",
      "items": [
        {
          "name": "Monolitik zirkonyum",
          "text": "Kuronun tamamı frezelenmiş zirkonyumdur; sinterlenir ve parlatılır. Azı dişleri ve diş sıkan herkes için en güçlü seçenek. Katmanlı seramikten daha az yarı saydamdır; bu yüzden bir ön dişte renk ve yüzey dokusu dikkatle işlenmezse düz görünebilir."
        },
        {
          "name": "Katmanlı zirkonyum",
          "text": "Zirkonyum kor üzerine porselen işlenir. Işığın dişten geçmesi gereken ön bölgede daha iyidir, ancak kaplama porseleni kırılabilir — bu tasarımın olağan başarısızlığıdır. Küçük azılar ve görünür dişler için makul bir uzlaşma."
        },
        {
          "name": "Karşılaştırma için metal-seramik",
          "text": "Metal bir kor üzerine porselen: öngörülebilir, daha ucuz ve çok iyi kanıtlanmış. Zayıflığı estetiktir — opak bir kor ve yıllar içinde diş eti metal kenardan çekildikçe oluşan gri çizgi."
        }
      ]
    },
    "journey": {
      "heading": "Preparasyondan simanlanmış kurona",
      "steps": [
        {
          "name": "Değerlendirme",
          "text": "Önce dişin neden kuron gerektirdiği belirlenir: bir çatlak, büyük bir eski dolgu, kanal tedavisi. Diş eti üzerinde ne kadar diş kaldığı, kuronun yeterli olup olmadığına karar verir."
        },
        {
          "name": "Preparasyon",
          "text": "Lokal anestezi altında diş 1–1,5 mm azaltılır; porselen kaplanacaksa daha fazla. Tarama veya ölçü alınır ve diş korunsun ve hareket etmesin diye geçici kuron takılır."
        },
        {
          "name": "Tasarım ve frezeleme",
          "text": "Kuron CAD'de tasarlanır, zirkonyum bloktan frezelenir ve yüksek sıcaklıkta sinterlenir, ardından renklendirilip sırlanır. Renk burada belirlenir — ameliyathane ışığında alınan renk gün ışığında yanlış görünür."
        },
        {
          "name": "Prova ve simanlama",
          "text": "Simanlamadan önce uyum, temas noktaları ve renk kontrol edilir. Ardından kuron rezin veya cam iyonomer simanla oturtulur ve temaslar eşit hissedilene kadar kapanış düzenlenir."
        },
        {
          "name": "Kontrol",
          "text": "Bir–iki hafta içinde, esas olarak kapanış için kontrol. Sıkma belirtileri varsa gece plağı yapılır — kuron dişi korur, kendini ağır bir kapanıştan korumaz."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Zirkonyum güçlüdür, ama kuron, bir kez başarısız olmuş bir dişin üzerindeki restorasyondur. Gerçekçi sorunlar bunlar.",
      "items": [
        "Kor kısa veya siman zayıflamışsa kuron çıkabilir — genellikle yeniden simanlanabilir",
        "Katmanlı porselenin kırılması; en sık ince kuronda veya ağır kapanış taşıyan dişte",
        "Zirkonyum minedan serttir ve yüzey parlatılmadıysa yıllar içinde karşıt dişi aşındırabilir",
        "Monolitik kuron ön bölgede, özellikle parlak ışıkta opak veya fazla tekdüze görünebilir",
        "Zaten zayıflamış bir dişin preparasyonundan sonra pulpa iltihabı veya kanal tedavisi ihtiyacı"
      ],
      "note": "Bir kuron ancak altındaki doku kadar iyidir. Diş etinin altında çatlak varsa ya da çok az doku kaldıysa, dürüst seçenek aynı dişe üçüncü bir kuron yapmak değil, çekim ve implant olabilir."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Metal-seramikten daha mı iyi?",
          "a": "Diş eti hizasında evet: metal yaka yoktur, bu yüzden diş eti çekildikçe gri çizgi oluşmaz. Renk ve yarı saydamlıkta iyi katmanlanmış bir seramik hâlâ daha iyi görünebilir. Monolitik zirkonyum gerçekçilikte değil, güçte kazanır."
        },
        {
          "q": "Zirkonyum kırılır mı?",
          "a": "Monolitik kuron bir bütün olarak nadiren kırılır — rutin kullanımdaki en güçlü seramik kurondur. Sık görülen başarısızlık, katmanlı kuronda porselen tabakasının kırılmasıdır; onarılabilir ama görünmez olmaz."
        },
        {
          "q": "Arka dişlerde kullanılabilir mi?",
          "a": "Evet — asıl avantajı budur. Azı dişleri en ağır yükü taşır ve zirkonyum bunu cam seramikten daha iyi karşılar. İkinci büyük azı için genellikle monolitik kuron mantıklı seçimdir."
        },
        {
          "q": "Ne kadar dayanır?",
          "a": "On–on beş yıl adil bir beklentidir, bazen daha uzun. Sınırı nadiren zirkonyumun kendisi belirler: alttaki diş, diş eti kenarı ve kapanışın kontrol altında olup olmadığı belirler."
        }
      ]
    },
    "ctaBand": {
      "heading": "Dişin fotoğrafını gönderin",
      "text": "Yakın bir fotoğraf ve dişin röntgeni, zirkonyum kuronun mu, onleyin mi yoksa çekimin mi daha mantıklı bir onarım olduğunu — ve nedenini — söylemek için yeterli.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk ancak diş, diş etleri ve kapanış incelenip tıbbi geçmiş gözden geçirildikten sonra belirlenebilir; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "Zirkonyum Diş Kaplama İstanbul | Platinya Clinic",
    "seoDesc": "İstanbul'da zirkonyum kuron: monolitik ve katmanlı seçenekler, metal-seramik ile farkı, preparasyon ve riskler. Ücretsiz değerlendirme."
  },
  "/periodontics": {
    "title": "İstanbul'da Diş Eti Tedavisi (Periodontoloji)",
    "eyebrow": "Diş tedavileri",
    "lead": "Diş eti hastalığı, fırçalarken kanayan bir iltihap olarak başlar ve gevşeyip kaybedilen dişlerle sonuçlanabilir. Tedavi, kök yüzeyindeki bakteriyel birikimi temizler ve sonra oradan uzak tutar. Hastalık kontrol altına alınır, tamamen iyileştirilmez.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te periodontal muayene",
    "stats": [
      {
        "value": "1–4 seans",
        "label": "Diş taşı temizliği ve kök düzleştirme"
      },
      {
        "value": "6–8 hafta",
        "label": "Yeniden değerlendirmeye kadar"
      },
      {
        "value": "3–6 ay",
        "label": "İdame aralığı"
      }
    ],
    "candidate": {
      "heading": "Kimin tedaviye ihtiyacı var",
      "intro": "Diş eti kanayan hemen herkes başlangıç tedavisi için adaydır. Planı değiştiren, ceplerin ne kadar derin olduğu ve ne kadar kemik kaybedildiğidir.",
      "items": [
        "Ağrı olmasa bile fırçalarken veya diş ipi kullanırken kanama",
        "Diş eti hizasında görünen diş taşıyla birlikte sürekli ağız kokusu veya metalik tat",
        "Çekilmiş diş etleri ya da eskisinden uzun görünen dişler",
        "Sondalamada 4 mm'den derin cepler veya hareket etmeye başlamış dişler"
      ],
      "note": "Sigara belirtileri gizler: damarları daralttığı için diş etleri daha az kanar, hastalık ise sürer. Diyabet ve hamilelik de yanıtı değiştirir; ikisinin de sorulmasının nedeni budur."
    },
    "techniques": {
      "heading": "Temizlik, cerrahi veya greft",
      "intro": "Neredeyse her olgu aynı adımla başlar — kök üzerindekini temizlemek. Geri kalanı, dokunun sonrasında ne yaptığı belirler.",
      "items": [
        {
          "name": "Diş taşı temizliği ve kök yüzeyi düzleştirme",
          "text": "Lokal anestezi altında derin temizlik; genellikle her seferinde bir çeyrek çene. Diş eti hizasının altındaki diş taşı ve bakteriyel birikim uzaklaştırılır. Olguların çoğunda tedavi budur; cerrahi ancak cepler sonrasında derin kalırsa düşünülür."
        },
        {
          "name": "Küretaj ve flep cerrahisi",
          "text": "Başlangıç tedavisinden sonra cepler derin kalırsa diş eti kaldırılır, kök yüzeyleri doğrudan görüş altında temizlenir ve doku yeniden konumlandırılır. Yanıt vermeyen bölgeler için saklanır — ilk adım olarak kullanılmaz."
        },
        {
          "name": "Çekilme için diş eti grefti",
          "text": "Kök açığa çıkmış, hassas veya çekilme ilerliyorsa damaktan doku alınıp kökün üzerine greftlenir. Kökü örter ve diş etini kalınlaştırır; kaybedilmiş kemiği geri getirmez."
        }
      ]
    },
    "journey": {
      "heading": "Kayıttan idameye",
      "steps": [
        {
          "name": "Periodontal kayıt",
          "text": "Her dişin çevresinde sondalama derinliği, kanama skorları, hareketlilik ve kemik seviyesi için röntgenler. Değişimi sonradan ölçülebilir kılan bu kayıttır — onsuz tedavi izlenimle değerlendirilir."
        },
        {
          "name": "Başlangıç tedavisi",
          "text": "Bir–dört randevuda, bir–iki hafta arayla, derin ceplerde lokal anesteziyle diş taşı temizliği ve kök düzleştirme. Fırçalama tekniği aynı zamanda düzeltilir, çünkü temizlik yalnızca temiz bir başlangıç sağlar."
        },
        {
          "name": "Altı–sekiz haftada yeniden değerlendirme",
          "text": "Cepler yeniden ölçülür. Sığ cepler genellikle bir–iki milimetre iyileşir; derin olanlar çoğu zaman iyileşmez ve karar verilmesi gereken bölgeler bunlardır."
        },
        {
          "name": "Gerekirse cerrahi",
          "text": "Yalnızca yanıt vermeyen bölgeler için ve yalnızca yeniden değerlendirmeden sonra planlanır. Kulağa geldiğinden küçük bir işlemdir, ama yine de cerrahidir ve kendi iyileşme süresi vardır."
        },
        {
          "name": "İdame",
          "text": "Üç–altı ayda bir kontroller, sondalama tekrarlanarak. Dişlerin korunup korunmadığına karar veren kısım budur: biyofilmin rahatsız edilmeden yeniden oluşmasına izin verilen her yerde hastalık geri döner."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Hastaların komplikasyon dediği şeylerin çoğu aslında dokunun iyileşmesidir. Gerçek riskler farklıdır ve açıkça söylenmeye değer.",
      "items": [
        "İltihap çözüldükçe diş etleri çekilir; dişler uzun görünür ve kökler açığa çıkabilir — bu hasar değil, iyileşmedir",
        "Açığa çıkan köklerde soğuğa hassasiyet, bazen haftalarca",
        "Derin temizlik sonrası birkaç gün kanama ve ağrı, yemek yerken hassasiyet",
        "Hastalık kroniktir: idame yapılmazsa geri döner ve kaybedilen kemik geri büyümez",
        "İleri olgularda dişler yine de kaybedilebilir; amaç geri kalanı korumak, her dişin sözünü vermek değil"
      ],
      "note": "Değiştirebileceğiniz en önemli etken sigaradır: tedaviye yanıtı köreltir ve sizi daha erken getirecek kanamayı gizler. Bırakmak, prognozu herhangi bir gargaradan daha fazla değiştirir."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Derin temizlik dişlerimi gevşetir mi?",
          "a": "Hayır. Dişler birkaç gün gevşek hissedilebilir; çünkü onları destekleyen diş taşı gitmiştir ve şişlik inmiştir; doku iyileştikçe sıkılaşırlar. Kemik kaybı ileriyse diş zaten tedaviden önce hareketliydi."
        },
        {
          "q": "Bu bir tedavi mi?",
          "a": "Hayır — kontrol. Periodontit geçmez, ama durağan tutulabilir. Üç–altı ayda bir idame onu durağan tutan şeydir ve atlanması, dişlerin ileride kaybedilmesinin en sık nedenidir."
        },
        {
          "q": "Ağrılı mı?",
          "a": "Temizlik lokal anestezi altında yapılır, yani işlem sırasında değil. Sonrasında diş etleri iki–üç gün hassas olur ve kökler birkaç hafta soğuğa duyarlı kalabilir; ikisi de sıradan ağrı kesici ve hassasiyet giderici diş macunuyla geçer."
        },
        {
          "q": "Ne sıklıkla kontrole gelmeliyim?",
          "a": "Cepler derinse, sigara içiyorsanız veya diyabetiniz iyi kontrol edilmiyorsa üç ayda bir; daha hafif olgularda altı ayda bir. Aralık, bir kurala göre değil, yeniden değerlendirmedeki ölçümlere göre belirlenir."
        }
      ]
    },
    "ctaBand": {
      "heading": "Diş etlerinizin fotoğrafını gönderin",
      "text": "Diş eti hizasının fotoğrafı ve yakın tarihli bir röntgen, bunun gingivit mi, periodontit mi yoksa koltukta görülmesi gereken bir şey mi olduğu konusunda ilk görüş için yeterli.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Diş eti hastalığı ancak sondalama ve görüntüleme ile teşhis edilebilir; tedaviye uygunluk muayeneden sonra belirlenir ve sonuçlar hastadan hastaya değişir.",
    "seoTitle": "Diş Eti Tedavisi (Periodontoloji) İstanbul | Platinya",
    "seoDesc": "İstanbul'da diş eti tedavisi: derin temizlik, flep cerrahisi ve diş eti grefti, tedavi takvimi ve idame. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/facelift-surgery": {
    "title": "İstanbul'da Yüz Germe (Derin Düzlem Yüz Germe)",
    "eyebrow": "Yüz plastik cerrahisi",
    "lead": "Yüz germe, yaşla birlikte aşağı inen yüz ve boyun yumuşak dokusunu kaldırır ve artık ona uymayan deriyi alır. Yüzeydeki deriyi değil, çene hattını ve boynu değiştirir.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te yüz germe ön görüşmesi",
    "stats": [
      {
        "value": "2–4 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "1–2 gece",
        "label": "Hastanede kalış"
      },
      {
        "value": "2–3 hafta",
        "label": "Sosyal hayattan uzak kalma"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Ameliyat gevşekliği tedavi eder, kırışıklıkları değil. Kilosu sabit olan, derisinde hâlâ bir miktar elastikiyet bulunan ve kendisi gibi, ama dinlenmiş görünmek isteyen kişiler için uygundur.",
      "items": [
        "Çene hattı boyunca sarkma ve burundan ağza inen kıvrım",
        "Elmacık kemiklerinin üzerinde düzleşmeyle birlikte aşağı inmiş orta yüz",
        "Boyunda gevşek deri ve dikey bantlar",
        "Genel anestezi için yeterince iyi genel sağlık ve bir aydır sigara içmemek"
      ],
      "note": "Yüz germe yaşlanmayı durdurmaz: yüz sonrasında da aynı hızla değişmeye devam eder. İnce çizgiler, pigment ve güneş hasarı başka yollarla — lazer, peeling veya botulinum toksini — tedavi edilir ve çoğu zaman cerrahiyle birleştirilir, cerrahinin yerine geçmez."
    },
    "techniques": {
      "heading": "Neler yapılabilir, teknik nasıl seçilir",
      "intro": "Plan dokuya, kemiğe ve boyna göre, yüz yüze muayeneyle, yüz dinlenirken ve hareket hâlindeyken yapılır. Fotoğraf gevşekliği göstermez.",
      "items": [
        {
          "name": "Derin düzlem yüz germe",
          "text": "Yüzün derin katmanları serbestleştirilir ve tek bir ünite olarak kaldırılır; böylece çekim gücünü deri değil, güçlü doku taşır. En doğal çene hattını ve en uzun kalıcılığı verir; orta yüz aşağı inmişse kullanılan teknik budur."
        },
        {
          "name": "Daha kısa izli SMAS germe",
          "text": "Kas tabakası, daha derin serbestleştirme yapılmadan daha kısa bir kesiyle sıkılaştırılır. Daha kısa ameliyat süresi ve daha az şişlik; erken dönem gevşeklik için iyi bir seçenek — ancak orta yüzden çok alt yüzü ele alır."
        },
        {
          "name": "Boyun germe (platizmaplasti)",
          "text": "Boyun kasları orta hatta bir araya getirilir ve gevşek deri alınır; çene altındaki küçük bir kesi ve kulak arkası kesisi kullanılır. Çoğu zaman hastaların en çok fark ettiği kısım burasıdır."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden iyileşmeye",
      "steps": [
        {
          "name": "Görüşme ve planlama",
          "text": "Yüz otururken ve yatarken muayene edilir, boyun ve saç çizgisi değerlendirilir, fotoğraf çekilir. Tarih belirlenmeden önce kan testleri ve gerektiğinde kardiyoloji görüşü planlanır. İz ve yeri önceden konuşulur."
        },
        {
          "name": "Hazırlık",
          "text": "Sigara en az dört hafta önce bırakılır — yüzde yara iyileşmesindeki en büyük etkendir. Kan sulandırıcılar ve bazı takviyeler yaklaşık on gün önce kesilir, altı–sekiz saat açlık gerekir. İlk hafta için evde yardım ayarlayın."
        },
        {
          "name": "Ameliyat",
          "text": "Genel anestezi altında, genellikle iki–dört saat. Kesi kulağın önünden ve arkasından geçer, şakakta saç çizgisine girer; böylece kulak ve saçla gizlenir. Sıklıkla her iki tarafa bir–iki gün dren konur ve hastaların çoğu bir–iki gece kalır."
        },
        {
          "name": "İlk iki hafta",
          "text": "Şişlik ve morarma ikinci–dördüncü günlerde zirve yapar, sonra iner. Baş yüksekte tutulur, ilk günlerde soğuk kompres uygulanır ve dren klinikte çıkarılır. Hastaların çoğu yedi–on gün sonra — güneş gözlüğüyle — dışarı çıkabileceğini hisseder."
        },
        {
          "name": "Üçüncü–altıncı haftalar ve iz",
          "text": "Makyaj ve saç boyası yaklaşık iki hafta, egzersiz dört–altı hafta sonra başlar. İz iki–üç ay sert ve pembe kalır, sonra on iki–on sekiz ayda solar; mümkün olduğunca kulak arkasında ve saç çizgisinin içinde konumlanır."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Bu, fasiyal sinire yakın gerçek bir ameliyattır ve riskler karardan sonra değil, önce duyulmalıdır.",
      "items": [
        "Hematom — deri altında kan birikmesi; en sık görülen komplikasyon ve boşaltılması gerekebilir",
        "Fasiyal sinirde geçici zayıflık; genellikle haftalar–aylar içinde düzelir, kalıcı hasar nadirdir",
        "Deri iyileşme sorunları veya deri kaybı; sigara içenlerde ve dolaşımı zayıf kişilerde çok daha olası",
        "Geniş veya kalınlaşmış iz, kesi hattı boyunca küçük saç kaybı alanları ve kulak önünde genellikle aylar içinde düzelen uyuşma",
        "Asimetri ya da çok sıkı veya çok hafif bulunan bir sonuç; revizyon gerekebilir"
      ],
      "note": "Sigarayı, diyabeti, tansiyonu, kan sulandırıcıları ve geçirilmiş yüz ameliyatlarını ya da yüze yapılmış dolguları bize söyleyin. Dolgular ve ipler anatomiyle planı değiştirir; bunları saklamak, komplike bir ameliyata giden en kısa yoldur."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Farklı biri gibi mi görüneceğim?",
          "a": "Amaç, kendiniz gibi ama dinlenmiş görünmenizdir. Yüz germe, düşen dokuyu kaldırır; burnun, gözlerin şeklini veya yüzün karakterini değiştirmez. Ameliyatlı olduğu açıkça belli olan görünüm genellikle derinin fazla gergin çekilmesinden kaynaklanır; bu yüzden burada gerginliği derin katmanlar taşır."
        },
        {
          "q": "Sonuç ne kadar kalıcı?",
          "a": "Hastaların çoğu değişimi yedi–on yıl, boyunda ise genellikle daha uzun süre görür. Kalıcı değildir, çünkü yüz kendi hızında yaşlanmaya devam eder. Kilonun sabit tutulması ve derinin güneşten korunması ikisi de yardımcı olur."
        },
        {
          "q": "Ne zaman toplum içine çıkabilirim?",
          "a": "Çoğu kişi on–on dört gün sonra rahattır; kalan şişlik kolayca kapatılabilir. Yüz üç–altı ay boyunca oturmaya devam eder ve çene hattının nihai şekli o dönemde değerlendirilir."
        },
        {
          "q": "Göz kapağı ameliyatıyla birleştirilebilir mi?",
          "a": "Çoğu zaman evet — üst veya alt göz kapağı ameliyatı, kaş kaldırma ya da elmacık kemiklerine yağ transferi sıklıkla aynı seansta yapılır. Bunun güvenli olup olmadığı toplam ameliyat süresine ve sağlığınıza bağlıdır; görüşmede kararlaştırılır."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Üç fotoğraf — ön, üç çeyrek ve profil — cerrahın germenin doğru ameliyat olup olmadığını ve hangi tekniğin uygun olacağını söylemesi için yeterli. Koordinatörümüz plan, tarih ve yazılı fiyat teklifiyle döner.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Bu sayfa genel bilgilendirme amaçlıdır, tıbbi tavsiye değildir. Uygunluk, teknik ve riskler bir cerrahla yapılan görüşmede belirlenir.",
    "seoTitle": "Yüz Germe (Derin Düzlem) İstanbul | Platinya",
    "seoDesc": "İstanbul'da yüz germe: derin düzlem teknik, boyun germe, uygun adaylar, iyileşme ve riskler. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/chin-implants": {
    "title": "İstanbul'da Çene Estetiği (İmplant ve Genioplasti)",
    "eyebrow": "Yüz plastik cerrahisi",
    "lead": "Geriye çekik veya zayıf bir çene tüm yüzün dengesini değiştirir — burun daha büyük, çene hattı daha yumuşak, boy daha kısa görünür. Çene estetiği çeneyi implantla, kemiği kaydırarak ya da geçici olarak dolguyla öne çıkarır.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te çene estetiği ön görüşmesi",
    "stats": [
      {
        "value": "1–2 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "1 gece",
        "label": "Hastanede kalış"
      },
      {
        "value": "1–2 hafta",
        "label": "Belirgin şişlik"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Değerlendirme yalnızca çene değil, oran ve kapanışla ilgilidir. Çene; burun, dudaklar ve çene açısına göre yargılanır.",
      "items": [
        "Profilden bakıldığında alt dudağın hizasının gerisinde kalan çene",
        "Önden bakıldığında yumuşak veya kısa görünen çene hattı",
        "Travma veya geçirilmiş çene ameliyatı sonrası asimetri",
        "Profili dengede tutmak için burun estetiğiyle birlikte değerlendirilen çene"
      ],
      "note": "Dişler doğru kapanmıyorsa asıl sorun kapanıştır ve implant bunu düzeltmez. Bu, ortodonti ve çene-yüz cerrahisi değerlendirmesi, bazen de implant yerine çenenin kendisini kaydıran ortognatik cerrahi gerektirir."
    },
    "techniques": {
      "heading": "Neler yapılabilir, teknik nasıl seçilir",
      "intro": "Aynı ad altında üç farklı ameliyat satılır. Neyi hareket ettirdikleri, ne kadar geri alınabilir oldukları ve ne kadar kalıcı oldukları bakımından ayrılırlar.",
      "items": [
        {
          "name": "Silikon çene implantı",
          "text": "Alt dudağın içinden veya bazen çene altından açılan küçük bir kesiyle kemiğe yerleştirilen yumuşak, katı bir implant. Dolgunluk ve genişlik ekler, yaklaşık bir saat sürer, sonradan çıkarılabilir veya değiştirilebilir. İmplant kemiğin üzerinde durur, kemikle kaynaşmaz."
        },
        {
          "name": "Kaydırmalı genioplasti",
          "text": "Çene kemiği kesilir, öne — ya da aşağı veya yana — kaydırılır ve küçük plak ve vidalarla sabitlenir. Kendi kemiğiniz kullanıldığı için kayabilecek bir implant yoktur; implantın düzeltemeyeceği dikey uzunluk ve asimetriyi düzeltebilir. Daha büyük bir ameliyattır, şişliği daha fazladır."
        },
        {
          "name": "Hyalüronik asit dolgu",
          "text": "Klinikte bir saatten kısa sürede, işten uzak kalmadan yapılan geçici bir seçenek. Ameliyata karar vermeden önce dolgunluğun nasıl görüneceğini gösterir ve yaklaşık dokuz–on sekiz ay kalır. Kısa veya asimetrik bir kemiği düzeltemez."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden iyileşmeye",
      "steps": [
        {
          "name": "Görüşme ve planlama",
          "text": "Profil fotoğrafları, yüz ölçümü ve kapanış muayenesi. Kemik kaydırılacaksa veya kapanıştan kuşku duyuluyorsa sefalometrik röntgen ya da BT planlanır. İmplantın boyutu ve şekli yüzünüzün modeli üzerinde seçilir."
        },
        {
          "name": "Hazırlık",
          "text": "Kan testleri ve kesi ağız içinden yapılacaksa diş kontrolü — ağız içi ameliyattan önce dişler ve diş etleri sağlıklı olmalıdır. Sigara dört hafta önce bırakılır. Kan sulandırıcılar yaklaşık on gün önce kesilir ve altı–sekiz saat açlık gerekir."
        },
        {
          "name": "Ameliyat",
          "text": "Genel anestezi veya derin sedasyon altında, bir–iki saat. İmplant alt dudağın içinden açılan kesiyle yerleştirilir, böylece deride iz kalmaz; kesi eriyen dikişlerle kapatılır. Hastaların çoğu bir gece kalır."
        },
        {
          "name": "İlk hafta",
          "text": "Şişlik kırk sekiz–yetmiş iki saatte zirve yapar; alt dudak ve çene sert ve uyuşuk hissedilir. Yumuşak gıda, ön dişlerle çiğnememek, her öğünden sonra ağız gargarası ve baş yüksekte yatmak gerekir. Morarma boyuna doğru inebilir ve bir haftada geçer."
        },
        {
          "name": "İkinci–altıncı haftalar",
          "text": "Şişliğin çoğu iki–üç haftada geçer, kalanı üç ayda iner. Alt dudak uyuşukluğu yavaşça, bazen aylar içinde düzelir. Temaslı spor ve diş tedavisi yaklaşık altı hafta bekler."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Çene, mental sinire yakındır ve kesi ağzın hemen yanındadır; risk listesini ikisi de şekillendirir.",
      "items": [
        "Enfeksiyon; ağız içi keside daha olasıdır ve enfekte implant genellikle çıkarılmak zorundadır",
        "Alt dudak ve çenede duyu değişikliği; mental sinirin gerilmesi veya zedelenmesine bağlıdır — genellikle geçicidir, bazen değildir",
        "İmplantın hareket etmesi ya da kemik boyunca belirgin kenar; veya çok fazla/az bulunan dolgunluk ve asimetri, revizyon gerekebilir",
        "Uzun süre yerinde duran implantın altında kemik erimesi; yıllar içinde implantın daha kötü oturmasına yol açabilir",
        "Genioplastide: kanama, diş köklerinde zedelenme ve sabitleme plaklarıyla ilgili sorunlar"
      ],
      "note": "Geçirilmiş çene veya eklem ameliyatlarını, ortodontik tedaviyi, diş eti hastalığını ve varsa otoimmün bir durumu bize söyleyin. Dişlerinizi sıkıyorsanız veya çene eklemi ağrınız varsa da belirtin — çene kaydırıldıktan sonra eklem farklı yüklenir."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Yaptırdığım belli olur mu?",
          "a": "Amaç oran, hacim değil. Yüzünüze uygun seçilen bir implant çene olarak değil, daha belirgin bir çene hattı olarak okunur. Kesi dudağın içindedir, yüzde iz kalmaz; karşılığında kısa bir şişlik dönemi ve uyuşuk bir alt dudaktır."
        },
        {
          "q": "İmplant mı genioplasti mi — hangisi daha iyi?",
          "a": "İmplant daha hızlıdır, geri alınabilir ve öne dolgunluk eklemekte iyidir. Genioplasti kendi kemiğinizi kaydırır; çeneyi uzatabilir, asimetriyi düzeltebilir ve yabancı cisimden kaçınır — bedeli daha büyük bir ameliyattır. Doğru cevap, gerçekte neyin kısa olduğuna bağlıdır ve bu tahminle değil ölçümle belirlenir."
        },
        {
          "q": "İmplant ne kadar dayanır?",
          "a": "Silikon implantın değiştirilmesi beklenmez ve birçoğu onlarca yıl yerinde kalır. Ancak hiç ilgi gerektirmeyecek anlamında kalıcı değildir: çıkarılabilir veya değiştirilebilir; ağrı olursa, kayarsa ya da çene şekil değiştirirse kontrol edilmelidir."
        },
        {
          "q": "Burun ameliyatıyla birlikte yapılabilir mi?",
          "a": "Evet ve çoğu zaman daha doğru plan budur: profil, burun ile çene arasındaki bir ilişkidir ve yalnızca birini değiştirmek diğerini yanlış gösterebilir. Birleşik ameliyat daha uzun sürer; bu yüzden tek işlem ve tek iyileşme olarak planlanır."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Bir profil ve bir ön görünüm, sorunun çene olup olmadığını ve implantın, kemiğin mi yoksa dolgunun mu mantıklı yol olduğunu söylemek için yeterli. Koordinatörümüz plan ve yazılı fiyat teklifiyle döner.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Bu sayfa genel bilgilendirme amaçlıdır, tıbbi tavsiye değildir. Uygunluk, teknik ve riskler bir cerrahla yapılan görüşmede belirlenir.",
    "seoTitle": "Çene Estetiği: İmplant ve Genioplasti | Platinya Clinic",
    "seoDesc": "İstanbul'da çene estetiği: silikon implant, kaydırmalı genioplasti ve dolgu seçenekleri, uygun adaylar ve riskler. Ücretsiz değerlendirme."
  },
  "/blepharoplasty": {
    "title": "İstanbul'da Göz Kapağı Estetiği (Blefaroplasti)",
    "eyebrow": "Yüz plastik cerrahisi",
    "lead": "Blefaroplasti, üst göz kapağındaki fazla deriyi ve alt kapağı yorgun, şişkin gösteren yağı alır. Yüzdeki en küçük ameliyatlardan biri ve yanlış yapılması en kolay olanlardan biridir.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te göz kapağı estetiği ön görüşmesi",
    "stats": [
      {
        "value": "1–2 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "5–7 gün",
        "label": "Dikişlerin alınması"
      },
      {
        "value": "7–10 gün",
        "label": "Sosyal hayata dönüş"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Ameliyat deriyi ve yağı tedavi eder; derinin rengini veya kalitesini değil. Pigment kaynaklı koyu halkalar ya da göz altındaki çöküklük farklı bir sorun ve farklı bir cevaptır.",
      "items": [
        "Kirpiklerin üzerine düşen, görüş alanını daraltan ağır üst kapaklar",
        "Kırışmış, ağırlaşmış veya asimetrik üst kapak derisi",
        "Sıvıdan değil, öne doğru yer değiştiren yağdan kaynaklanan şişkin alt kapaklar",
        "Görünür bir yağ torbasıyla birlikte ya da tek başına gevşek alt kapak derisi"
      ],
      "note": "Kuru göz, tiroid göz hastalığı, glokom ve yüksek tansiyon planı değiştirir; bazıları beklemek için nedendir. Tiroid hastalığı ameliyattan önce stabil olmalıdır: aktif tiroid göz hastalığında ameliyat durumu kötüleştirebilir."
    },
    "techniques": {
      "heading": "Neler yapılabilir, teknik nasıl seçilir",
      "intro": "Üst ve alt kapak ayrı kararlardır. Hastaların çoğu yalnızca birine ihtiyaç duyar; gereğinden fazlasını yapmak, göz kapaklarının çökük görünmesine yol açan şeydir.",
      "items": [
        {
          "name": "Üst kapak blefaroplastisi",
          "text": "Doğal kıvrım içinde ince bir kesi, fazla deri ve onunla birlikte bir şerit kas alınır; yağ yalnızca taşkın olduğu yerde düzeltilir. İz kıvrımın içinde kalır ve üç–altı ayda solar. Görüş alanını genişleten kısım budur."
        },
        {
          "name": "Alt kapak, transkonjonktival",
          "text": "Yağ, kapağın iç yüzünden alınır; deri kesisi ve dışarıda iz yoktur. Cilt tonu iyi olan yağ torbaları için uygundur; gevşek deriyi almaz. Sıklıkla gözyaşı oluğunu doldurmak için yağın yeniden yerleştirilmesiyle birleştirilir."
        },
        {
          "name": "Alt kapak, dıştan ve kantopeksi ile",
          "text": "Kirpiklerin hemen altındaki bir kesi yağın yanı sıra deriyi de alır ve kapak köşesi düşmemesi için desteklenir. Gerçek deri fazlalığı olduğunda kullanılır — kapağın aşağı çekilme riskinin en dikkatli yönetilmesi gereken tekniktir."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden iyileşmeye",
      "steps": [
        {
          "name": "Görüşme ve planlama",
          "text": "Kapaklar gözler açık ve kapalıyken incelenir, korunacak deri miktarı ölçülür ve kuru göz değerlendirilir. Fotoğraf çekilir. Gözyaşı filmi veya tiroid konusunda en ufak kuşku varsa, tarih belirlenmeden önce göz hastalıkları görüşü alınır."
        },
        {
          "name": "Hazırlık",
          "text": "Kan sulandırıcılar, aspirin ve bazı takviyeler yaklaşık on gün önce kesilir, sigara dört hafta önce bırakılır. Altı–sekiz saat açlık gerekir. Sizi eve götürecek birini ayarlayın: gözler şiş olacağı için araba kullanamazsınız."
        },
        {
          "name": "Ameliyat",
          "text": "Hafif sedasyonlu lokal anestezi veya genel anestezi; iki kapak için bir–iki saat. Lokal anestezide uyanıksınızdır ve cerrahla konuşabilirsiniz. Dikişler incedir ve beş–yedi gün sonra alınır; bazıları kendiliğinden erir."
        },
        {
          "name": "İlk hafta",
          "text": "Morarma ve şişlik beklenir, ilk üç–dört günde belirgin olabilir. Soğuk kompres, başın yüksekte tutulması ve göz damlaları. Bulanık görme ameliyattan değil merhemden kaynaklanır. Yaklaşık iki hafta kontakt lens kullanılmaz."
        },
        {
          "name": "İkinci–on ikinci haftalar",
          "text": "Çoğu kişi yedi–on gün sonra dışarı çıkabilecek durumdadır; makyaj yaklaşık onuncu günden itibaren kullanılabilir. Kalan şişlik dört–altı haftada, iz üç–altı ayda yumuşar. Bu dönemde kapaklarda güneş koruması önemlidir."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Göz kapağı ameliyatının kısa bir risk listesi vardır ve bunlardan biri acil bir durumdur. Hepsini ameliyattan önce okumakta yarar var.",
      "items": [
        "Alt kapağın ektropiyonu veya retraksiyonu — kapak aşağı çekilir, göz tam kapanmaz, kuru ve batmalı hâle gelir; revizyon gerekebilir",
        "İki taraf arasında asimetri veya düzeltilmesi zor olan aşırı deri alımı",
        "Göz arkasında hematom — nadir ama görme kaybı riski taşır ve hemen geri dönmek için nedendir",
        "Gözü hareket ettiren kaslarda zedelenmeye bağlı çift görme; genellikle geçici, nadiren kalıcı",
        "Belirgin veya kalınlaşmış izler ve kesi hattı boyunca küçük kistler"
      ],
      "note": "Kuru göz, kontakt lens kullanımı, tiroid hastalığı, glokom, kanama bozuklukları ve aspirin ile balık yağı dahil kullandığınız tüm kan sulandırıcıları bize söyleyin. Göz çevresinde dolgu veya lazer yaptırdıysanız da belirtin — bu, dokunun davranışını değiştirir."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Gözlerimin şekli değişir mi?",
          "a": "Şekli kapaklar ve kaş belirler; ameliyat da bunlara göre planlanır. Deri almak gözü açar; gözü daha yuvarlak veya şaşkın göstermemelidir. Kaş düşükse, daha fazla deri almak yerine kaşı kaldırmak çoğu zaman doğru cevaptır."
        },
        {
          "q": "Koyu halkaları giderebilir mi?",
          "a": "Kısmen, ve yalnızca koyuluk bir yağ torbasının ya da çöküklüğün oluşturduğu gölgeyse. Derideki pigmentten kaynaklanan koyuluk ameliyatla değişmez; kremler, peelingler veya lazerle tedavi edilir. Bu, ameliyatla ilgili en sık yanlış anlaşılan noktadır."
        },
        {
          "q": "Sonuç ne kadar kalıcı?",
          "a": "Genellikle beş–on yıl, üst kapaklarda bazen daha uzun. Deri yaşlanmaya, kaş ise düşmeye devam eder; yani sonuç kalıcı bir durum değil, bir iyileşmedir. Yıllar sonra bazen ikinci, daha küçük bir işlem yapılır."
        },
        {
          "q": "Üst mü alt mı — hangisine ihtiyacım var?",
          "a": "Buna muayene karar verir. Ağırlaşmış kapak ve daralmış görüş alanı üst kapağı; şişkinlik ve göz altındaki gölge alt kapağı işaret eder. Hastaların çoğuna yalnızca biri önerilir; ikisini birleştirmek, sonuç kadar iyileşme süresiyle ilgili bir karardır."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Gözler açık bir ön fotoğraf ve gözler hafifçe kapalı bir fotoğraf, cerrahın hangi kapağın işlem gerektirdiğini ve ne kadar derinin güvenle korunabileceğini değerlendirmesi için yeterli. Koordinatörümüz plan ve yazılı fiyat teklifiyle döner.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Bu sayfa genel bilgilendirme amaçlıdır, tıbbi tavsiye değildir. Uygunluk, teknik ve riskler bir cerrahla yapılan görüşmede belirlenir.",
    "seoTitle": "Göz Kapağı Estetiği (Blefaroplasti) İstanbul | Platinya",
    "seoDesc": "İstanbul'da göz kapağı estetiği: üst ve alt kapak teknikleri, uygun adaylar, iyileşme ve riskler. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/silicone": {
    "title": "İstanbul'da Silikon Meme Protezi ile Meme Büyütme",
    "eyebrow": "Vücut şekillendirme",
    "lead": "Meme büyütme, meme dokusunun veya kasın arkasına yerleştirilen bir protezle hacim ekler ve simetriyi iyileştirir. Boyutu ve şekli değiştirir; sarkmış bir memeyi kaldırmaz.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te meme büyütme ön görüşmesi",
    "stats": [
      {
        "value": "1–2 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "1 gece",
        "label": "Hastanede kalış"
      },
      {
        "value": "4–6 hafta",
        "label": "Sporsuz dönem"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Başlangıç noktası, istediğiniz cup ölçüsü değil sahip olduğunuz dokudur — kalınlığı, elastikiyeti ve meme ucunun nerede durduğu. Protez göğse uyacak şekilde seçilir.",
      "items": [
        "Doğal olarak küçük memeler ya da vücudun geri kalanıyla hiç örtüşmemiş bir boyut",
        "İki taraf arasında belirgin asimetri",
        "Emzirme veya kilo kaybı sonrası, deri hâlâ sıkıyken kaybedilen hacim",
        "Üst kutupta boş görünen, ölçülü bir protezin dış hattı geri kazandırdığı meme"
      ],
      "note": "Meme ucu, memenin altındaki kıvrımın altındaysa sorun pitozistir ve yalnızca protez bunu düzeltmez — kötüleştirebilir. Bu durumda protezli ya da protezsiz bir germe gerekir. Yaşınıza ve aile öykünüze göre ameliyattan önce mamografi veya ultrason planlanır ve herhangi bir kitle önce araştırılır."
    },
    "techniques": {
      "heading": "Neler yapılabilir, teknik nasıl seçilir",
      "intro": "Üç karar birlikte verilir: ne yerleştirilecek, nereye yerleştirilecek ve nasıl yerleştirilecek. Her biri görünümü, iyileşmeyi ve riski değiştirir.",
      "items": [
        {
          "name": "Protez: yuvarlak veya anatomik",
          "text": "Modern protezler şeklini koruyan koheziv silikon jel ile doludur. Yuvarlak protezler üst kutupta dolgunluk verir; anatomik (damla) protezler doğal eğimi izleyecek şekilde biçimlendirilir ve dönmemeleri için genellikle pürüzlüdür. Yüzey ve şekil cerrahla birlikte seçilir ve ikisinin de ödünleşmeleri vardır."
        },
        {
          "name": "Katman: kas altı veya dual-plan",
          "text": "Pektoral kasın arkasına yerleştirme protezin kenarını gizler ve ince dokuya uygundur; dual-plan, kasın alt kısmını serbestleştirir, böylece protez doğal otururken üst kısım onu örtmeye devam eder. Kas üstü daha hızlı iyileşir ama ince hastalarda daha çok belli olur."
        },
        {
          "name": "Kesi",
          "text": "Memenin altındaki kıvrımda en sık kullanılır ve en doğrudan kontrolü sağlar. Areola çevresi izi pigment değişiminin içinde gizler ama meme ucu duyusunun değişme riski biraz daha yüksektir; koltuk altından yapılan memede iz bırakmaz ama daha az hassastır."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden iyileşmeye",
      "steps": [
        {
          "name": "Görüşme ve planlama",
          "text": "Göğüs ölçüleri, deri kalitesi ve meme ucu konumu; istediğiniz boyut üzerine bir konuşma — fotoğraftan değil, deneme protezleriyle. Gerektiğinde mamografi veya ultrason, kan testleri ve protezin adını belirten yazılı bir plan."
        },
        {
          "name": "Hazırlık",
          "text": "Sigara dört hafta, kan sulandırıcılar ve bazı takviyeler yaklaşık on gün önce bırakılır, altı–sekiz saat açlık gerekir. Ameliyat sütyenini önceden alın ve ilk üç–dört gün için yardım ayarlayın: ağırlık kaldırmak ve araba kullanmak mümkün değil."
        },
        {
          "name": "Ameliyat",
          "text": "Genel anestezi altında, bir–iki saat. Protez yerleştirilir, ameliyat sırasında siz oturtulurken pozisyon kontrol edilir ve kesi katmanlar hâlinde kapatılır. Hastaların çoğu bir gece kalır; taburculuktan önce kompresyon sütyeni giydirilir."
        },
        {
          "name": "İlk iki hafta",
          "text": "Gerginlik ve şişlik ilk üç–beş günde daha belirgindir ve memeler yüksekte durur. Kompresyon sütyeni gece gündüz giyilir, dren nadirdir ve ilk duş klinikte planlanır. Sırt üstü, destekli yatmak daha rahattır."
        },
        {
          "name": "Üçüncü–altıncı haftalar",
          "text": "Şişlik iner ve protezler altı–on iki hafta içinde yerine oturur. Masa başı işe genellikle bir–iki hafta sonra dönülür. Spor salonu, koşu, yüzme ve ağır kaldırma dört–altı hafta bekler; üst vücut çalışmaları sonrasında kademeli başlar."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Protez bir cihazdır; bir ömrü ve bir başarısızlık oranı vardır. Nadir olanlar dahil önemli riskler bunlar.",
      "items": [
        "Kapsül kontraktürü — protezin çevresindeki nedbe dokusu sıkışır, memeyi sert, yuvarlak ve bazen ağrılı yapar; tedavi edilebilir ama tekrarlayabilir",
        "BIA-ALCL, protez kapsülünün nadir bir lenfoması; esas olarak pürüzlü protezlerle ilişkilidir ve yıllar sonra şişlik veya sıvı birikmesiyle ortaya çıkar. Protez ve kapsülün çıkarılmasıyla tedavi edilir",
        "Rüptür veya sızıntı; hiç belirti vermeyebilir ve görüntülemede saptanır. İnce deride dalgalanma veya görünür kenarlar",
        "Enfeksiyon; protezin çıkarılmasını ve sonra yerine yenisinin konmasını gerektirebilir. Meme ucu veya meme duyusunda değişim — genellikle geçici, bazen kalıcı",
        "Kanama, hematom ve nadiren tromboz — erken yürüyüş ve kompresyonla azalır"
      ],
      "note": "Geçirilmiş meme ameliyatlarını, ailede meme veya yumurtalık kanseri öyküsünü, otoimmün hastalığı ve sigarayı bize söyleyin. Protezler meme kanseri taramasını engellemez, ancak mamografinin nasıl yapıldığını değiştirir — randevu alırken proteziniz olduğunu söyleyin."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Protezler ne kadar dayanır?",
          "a": "Ömür boyu kullanılan cihazlar değildir. Birçoğu on–on beş yıl veya daha fazla dayanır, ancak rüptür, kontraktür ya da şekil değişimi değişimi öne çekebilir. Sabit bir değiştirme takvimi yoktur: protez muayeneyle, gerektiğinde ultrason veya MR ile kontrol edilir ve bir neden varsa değiştirilir."
        },
        {
          "q": "Emzirebilecek miyim?",
          "a": "Kadınların çoğu emzirebilir; özellikle kıvrımdaki kesi ve dual-plan yerleşimde süt kanalları ve sinir desteği büyük ölçüde korunur. Bazı kadınlar daha az süt üretir ve areola kesisi meme ucu duyusunun değişme riskini artırır. Ameliyatı ilerideki hamileliği düşünerek planlamakta yarar var."
        },
        {
          "q": "Protezler meme kanserine yol açar mı?",
          "a": "Silikon protezlerin meme kanserine yol açtığı gösterilmemiştir. BIA-ALCL, protez çevresindeki nedbe kapsülünün ayrı ve nadir bir lenfomasıdır, meme kanseri değildir; protez çevresinde yeni bir şişlik, kitle veya ağrının izlenmek yerine araştırılmasının nedeni de budur. Risk düşüktür ama gerçektir ve var olduğunu bilmelisiniz."
        },
        {
          "q": "Bunun yerine germe mi gerekli?",
          "a": "Meme ucu kıvrım hizasında veya altındaysa evet — ya da daha küçük protezle birlikte germe. Protez hacmi öne ekler, yukarı değil; sarkmış bir memede daha ağır ve daha düşük bir şekil oluşturabilir. Bu ayakta muayene edilir ve görüşmede planın değişmesinin en sık nedenidir."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Vücuda oturan bir üstle çekilmiş ön ve yan görünümler, yalnızca protezin yeterli olup olmadığını, vücudunuza kabaca hangi hacmin uyduğunu ve ameliyatın neleri kapsadığını konuşmak için yeterli. Koordinatörümüz plan ve yazılı fiyat teklifiyle döner.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Bu sayfa genel bilgilendirme amaçlıdır, tıbbi tavsiye değildir. Uygunluk, teknik ve riskler bir cerrahla yapılan görüşmede belirlenir.",
    "seoTitle": "Silikon Meme Protezi ile Meme Büyütme | Platinya",
    "seoDesc": "İstanbul'da silikon meme protezi ile meme büyütme: yuvarlak ve anatomik protez, kas altı ve dual-plan, riskler. Ücretsiz değerlendirme."
  },
  "/butt-augmentation-surgery": {
    "title": "İstanbul'da Kalça Büyütme (BBL)",
    "eyebrow": "Vücut şekillendirme",
    "lead": "Kalça büyütme, vücudun başka bir yerinden yağ taşıyarak ya da implant yerleştirerek kalçanın şeklini ve dolgunluğunu değiştirir. Vücut şekillendirmede hem cerrah hem de iyileşme açısından en zorlu ameliyatlardan biridir.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te kalça büyütme ön görüşmesi",
    "stats": [
      {
        "value": "3–5 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "1–2 gece",
        "label": "Hastanede kalış"
      },
      {
        "value": "2–3 hafta",
        "label": "Dikkatli oturma"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Yağ transferi için transfer edilecek yağ ve yeni hacmi kaldırabilecek deri gerekir. İkisi de ayakta değerlendirilir ve ameliyatın mümkün olup olmadığına birlikte karar verir.",
      "items": [
        "Karın, yanlar, sırt veya uylukta alınacak yeterli yağ ve sabit bir kilo",
        "Profilden bakıldığında düz, kare ya da dolgunluğu olmayan kalça",
        "Asimetri veya kilo kaybı sonrası şekil kaybı",
        "İyi cilt tonu; pıhtılaşma öyküsü ve geçirilmiş liposuction sorunu olmaması"
      ],
      "note": "Bu bir kilo verme ameliyatı değildir ve egzersizin yerini tutmaz. Zayıfsanız alınacak yağ olmayabilir ve tek yol implanttır — ki onun riskleri farklıdır. Sigara, pıhtılaşma bozuklukları ve kontrol altında olmayan diyabet yeniden düşünmek için nedenlerdir."
    },
    "techniques": {
      "heading": "Neler yapılabilir, teknik nasıl seçilir",
      "intro": "Aynı adı taşıyan iki ayrı ameliyat var. Birbirinin varyasyonu değiller: malzeme, iyileşme ve ciddi riskler bakımından farklıdırlar.",
      "items": [
        {
          "name": "Yağ transferi (Brezilya kalça kaldırma)",
          "text": "Yağ karın, yanlar veya sırttan liposuction ile alınır, yıkanır ve dinlendirilir, ardından küçük geçişlerle kalçaya enjekte edilir. Kendi dokunuz olduğu için doğal hissettirir ve verici bölgeler aynı seansta şekillendirilir. Yağın tamamı yaşamaz."
        },
        {
          "name": "Kalça implantı",
          "text": "Katı silikon implant, kalça arasındaki kıvrımdan açılan bir kesiyle fasya altına veya kas içine yerleştirilir. Küçülmeyen, öngörülebilir bir hacim verir; ancak yabancı cisimdir ve kayma, enfeksiyon ile kapsül oluşumu riski taşır, iz de hassas bir bölgede kalır."
        },
        {
          "name": "Kombinasyon ve revizyon",
          "text": "Yağ transferi küçük bir implantla birleştirilebilir veya ilk transfer oturduktan sonra hacim eklemek için altı–on iki ay sonra tekrarlanabilir. Daha önce yapılmış bir BBL'nin revizyonu genellikle ilk ameliyattan daha zordur, çünkü nedbe dokusu katmanları değiştirir."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden iyileşmeye",
      "steps": [
        {
          "name": "Görüşme ve planlama",
          "text": "Ayakta fotoğraflar, verici yağ ve deri elastikiyetinin değerlendirilmesi, pıhtılaşma, kanama ve geçirilmiş ameliyatları içeren bir tıbbi geçmiş. Tarih belirlenmeden önce kan testleri, gerektiğinde kardiyoloji veya anestezi görüşü."
        },
        {
          "name": "Hazırlık",
          "text": "Sigara en az dört hafta önce bırakılır; nikotin yağın yaşamasını ve iyileşmeyi etkiler. Kan sulandırıcılar, doğum kontrol hapı ve bazı takviyeler konuşulur, uygun olanlar kesilir. Bol kıyafet ve BBL yastığı alın, evde yardım ayarlayın — haftalarca normal yatamayacak ve oturamayacaksınız."
        },
        {
          "name": "Ameliyat",
          "text": "Genel anestezi altında, üç–beş saat. Yağ alınır, işlenir ve derin damarlardan uzak durmaya özen gösterilerek küçük porsiyonlar hâlinde enjekte edilir. Korse giydirilir; hastaların çoğu bir–iki gece kalır."
        },
        {
          "name": "İlk iki hafta",
          "text": "Yüzüstü veya yan yatarak uyursunuz ve yalnızca özel yastığa, kısa sürelerle oturursunuz. Verici bölgeler morarmış ve hassastır, korse sürekli giyilir. İlk günden itibaren yürüyüş teşvik edilir; kalçalar şiştir ve şekil henüz nihai değildir."
        },
        {
          "name": "Üçüncü–on ikinci haftalar",
          "text": "Oturmak iki–üç haftada, araba kullanmak iki–üç haftada, egzersiz altı–sekiz haftada rahatlar. Şişlik üç ayda iner; yaşayan yağ kalıcıdır, ancak nihai şekil üç–altıncı ayda değerlendirilir."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Bu ameliyatın kendine özgü ciddi bir riski var ve bu, geçerken anılmak yerine açıkça söylenmelidir.",
      "items": [
        "Yağ embolisi — yağın kan dolaşımına girip akciğerlere ulaşması; ölümcül olabilir ve hiçbir teknik riski tamamen ortadan kaldırmaz",
        "Yağ nekrozu, yağ kistleri ve transfer edilen bölgelerde sertleşme; bazen drenaj gerekir",
        "Enfeksiyon — derin kalça katmanında tedavisi zor olabilir ve implantın çıkarılmasını gerektirebilir; ayrıca verici bölgelerde seroma veya gecikmiş iyileşme",
        "Asimetri, kontur düzensizliği veya planlanandan küçük bir sonuç; çünkü yağın değişken bir kısmı yaşamaz",
        "Tromboz veya pulmoner emboli — erken yürüyüş ve kompresyonla azalır; implantlarda ayrıca kayma, kapsül kontraktürü ve kalınlaşmış izler"
      ],
      "note": "Herhangi bir kliniğe doğrudan sorun: derin damar içi enjeksiyondan nasıl kaçınıyor, anesteziyi kim veriyor ve komplikasyon olursa ne oluyor? Yağ embolisi konusunda kaçamak cevap veren bir klinik, randevu alınacak bir klinik değildir."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Yağın ne kadarı yaşıyor?",
          "a": "Değişken bir oran — çoğu zaman önemli bir kısmı emilir ve sonuç, ameliyat sonrası ilk hacimden küçük olur. Bu yüzden ameliyat temkinli planlanır ve bazen altı–on iki ay sonra ikinci bir seans gerekir. Hiçbir cerrah yüzde garanti edemez."
        },
        {
          "q": "Ne zaman normal oturabilirim?",
          "a": "İki–üç hafta boyunca yalnızca yastığa ve kısa sürelerle oturma, yüzüstü veya yan yatma. İlk haftalarda uzun süreli basıncın yağın yaşamasını azalttığı düşünülür. Araba kullanmak iki–üç, uzun uçuşlar dört–altı hafta bekler."
        },
        {
          "q": "BBL tehlikeli mi?",
          "a": "Ölümcül olabilen gerçek bir yağ embolisi riski taşır ve bu risk çoğu estetik ameliyattan yüksektir. Dikkatli teknikle — küçük kanüller, derin kas ve büyük damarlardan kaçınma, hacmin sınırlanması — azalır ama ortadan kalkmaz. Riskin buna değmediğine karar vermek de meşru bir tercihtir."
        },
        {
          "q": "Yağ mı implant mı — hangisi daha iyi?",
          "a": "Yağ doğal bir his verir ve verici bölgeleri şekillendirir; ancak hacmin bir kısmı kaybolur ve sınır, ne kadar yağınız olduğudur. İmplant, ikinci bir ameliyat bölgesi olmadan öngörülebilir hacim verir; bedeli yabancı cisim ile daha yüksek enfeksiyon ve kayma riskidir. Genellikle kendi yağ dağılımınız kararı verir."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Vücuda oturan kıyafetle çekilmiş yan ve arka görünümler, cerrahın dolgunluğu ve verici yağı değerlendirmesini ve transferin mümkün olup olmadığını dürüstçe söylemesini sağlar. Koordinatörümüz plan ve yazılı fiyat teklifiyle döner.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Bu sayfa genel bilgilendirme amaçlıdır, tıbbi tavsiye değildir. Uygunluk, teknik ve riskler bir cerrahla yapılan görüşmede belirlenir.",
    "seoTitle": "Kalça Büyütme (BBL) İstanbul | Platinya Clinic",
    "seoDesc": "İstanbul'da kalça büyütme: yağ transferi ve implant seçenekleri, uygun adaylar, iyileşme ve riskler. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/liposuction": {
    "title": "İstanbul'da Liposuction (VASER ve Tumessan)",
    "eyebrow": "Vücut şekillendirme",
    "lead": "Liposuction, vücudun dış hatlarını değiştirmek için belirli bölgelerden yağ alır. Bir şekillendirme ameliyatıdır: tartı neredeyse değişmez, değişen yağın nerede durduğudur.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te liposuction ön görüşmesi",
    "stats": [
      {
        "value": "1–3 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "Aynı gün",
        "label": "veya bir gece"
      },
      {
        "value": "4–6 hafta",
        "label": "Korse"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Sonucu belirleyen iki şey, alınacak ne kadar yağ olduğu ve derinin sonrasında ne kadar toparlanacağıdır. Hastaların küçümsediği ikincisidir.",
      "items": [
        "Karın, yanlar, sırt, uyluk veya kollarda egzersizle değişmeyen yerel yağ",
        "Yaklaşık altı aydır sabit kilo ve korumayı düşündüğünüz kiloya yakın olmak",
        "Hâlâ elastikiyeti olan deri — yeni kontura göre büzülmesi gerekir",
        "Pıhtılaşma bozukluğu, kontrol altında olmayan diyabet veya kalp hastalığı olmaması"
      ],
      "note": "Liposuction obezite tedavisi değildir ve kilo vermenin yerini tutmaz. Verilecek çok kilo varsa, önce vermek daha iyi ve daha güvenli bir sonuç verir. Deri zaten gevşekse, altındaki yağı almak gevşekliği daha belirgin yapar — o durumda yağ almaya değil, deri almaya ihtiyaç vardır."
    },
    "techniques": {
      "heading": "Neler yapılabilir, teknik nasıl seçilir",
      "intro": "Tüm liposuction yöntemleri küçük kesilerden kanülle çalışır. Fark, yağın aspire edilmeden önce nasıl gevşetildiği ve tek seansta ne kadar alanın ele alındığıdır.",
      "items": [
        {
          "name": "Tumessan liposuction",
          "text": "Önce büyük hacimde seyreltilmiş lokal anestezik ve adrenalin enjekte edilir; bu bölgeyi uyuşturur, damarları daraltır ve kanamayı azaltır. Ardından yağ kanülle aspire edilir. Standart tekniktir ve diğer yöntemlerin çoğu bunun üzerine kuruludur."
        },
        {
          "name": "VASER (ultrason destekli)",
          "text": "Yağ alınmadan önce ultrason enerjisiyle gevşetilir. Çevre dokuya daha nazik olduğu ve özellikle sırt ile yanlarda derinin toparlanmasına yardımcı olduğu öne sürülür. Daha yavaştır, daha pahalıdır ve deri altında yanık riski taşır."
        },
        {
          "name": "360° şekillendirme",
          "text": "Karın, yanlar ve sırt tek bir kesintisiz ünite olarak ele alınır; böylece bel çevresindeki geçiş, ayrı ayrı bölgeler yerine pürüzsüz olur. Daha uzun bir ameliyat ve daha fazla hacim demektir; bu yüzden daha dikkatli planlanır ve daha uzun iyileşme gerektirir."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden iyileşmeye",
      "steps": [
        {
          "name": "Görüşme ve planlama",
          "text": "Bölgeler ayakta işaretlenir, deri elastikiyeti değerlendirilir ve beklenen hacim dürüstçe konuşulur — nelerin değişmeyeceği dahil. Tarih belirlenmeden önce kan testleri ve gerektiğinde kardiyoloji görüşü."
        },
        {
          "name": "Hazırlık",
          "text": "Sigara dört hafta, kan sulandırıcılar ve bazı takviyeler yaklaşık on gün önce bırakılır, altı–sekiz saat açlık gerekir. Korse ölçüsü alınır ve önceden sipariş edilir. İlk iki–üç gün için evde yardım ayarlayın."
        },
        {
          "name": "Ameliyat",
          "text": "Sedasyon veya genel anestezi altında, bölge sayısına göre bir–üç saat. Sıvı infiltre edilir, yağ birkaç milimetrelik kesilerden aspire edilir ve korse ameliyathanede giydirilir. Hastaların çoğu aynı gün eve gider; daha büyük hacimlerde bir gece kalınır."
        },
        {
          "name": "İlk iki hafta",
          "text": "Kesi yerlerinden bir–iki gün sıvı sızar ve korse gece gündüz giyilir. Morarma yaygındır ve ilk hafta zirve yapar. İlk günden yürüyüş; masa başı işe genellikle üç–yedi gün sonra dönülür."
        },
        {
          "name": "Üçüncü–on ikinci haftalar",
          "text": "Şişlik dört–altı haftada azalır ve korse bu süre boyunca devam eder. Egzersize dört–altı haftada başlanır. Kontur üç–altı ayda oturur; nihai sonuç altı–on ikinci ayda değerlendirilir."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Liposuction yaygındır ama hâlâ bir ameliyattır; estetik değil ciddi olan az sayıda riski vardır.",
      "items": [
        "Kontur düzensizliği, gamzelenme veya asimetri — en sık şikâyet ve düzeltilmesi en zor olan",
        "Yağ alındıktan sonra deri gevşekliği veya sarkması; elastikiyet baştan zayıfsa",
        "Yanıklar veya deri nekrozu; özellikle ultrason destekli tekniklerde",
        "Enfeksiyon, tekrarlayan drenaj gerektiren seroma ve kesi yerlerinde gecikmiş iyileşme",
        "Tromboz, pulmoner emboli ve yağ embolisi — nadir; erken yürüyüş ve kompresyonla azalır. Karın duvarında veya organlarda iç yaralanma daha da nadirdir ve agresif derin vakumla daha olasıdır"
      ],
      "note": "Kan sulandırıcıları, pıhtılaşma sorunlarını, kalp veya karaciğer hastalığını ve aynı bölgede geçirilmiş liposuction'ı bize söyleyin. Tek seansta güvenle alınabilecek miktarın bir sınırı vardır; istenen her hacmi kabul eden bir cerrah dikkatli davranmıyordur."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ne kadar kilo veririm?",
          "a": "Çok az, ve bu bilinçli bir tercihtir: yağ göründüğünden hafiftir ve tek seansta güvenli hacim sınırlıdır. Değişim vücut şeklinde ve kıyafetlerin oturmasındadır. Amaç kilo vermekse yanlış ameliyattır."
        },
        {
          "q": "Yağ geri gelir mi?",
          "a": "Alınan yağ hücreleri geri gelmez, ancak geride kalanlar kilo alırsanız büyüyebilir — ve genellikle eşit olarak büyürler, bu yüzden şekil değişebilir. Sonucu koruyan şey kiloyu sabit tutmaktır."
        },
        {
          "q": "Selüliti tedavi eder mi?",
          "a": "Güvenilir biçimde hayır. Selülit, yalnızca yağ değil; derinin ve altındaki fibröz bantların yapısıdır. Liposuction bazen gamzelenmeyi daha görünür kılabilir, çünkü onu dolduran yağı alır. Bunu selülit tedavisi olarak satan birine kuşkuyla yaklaşın."
        },
        {
          "q": "Sonucu ne zaman görürüm?",
          "a": "Erken değişim iki–üç haftada görülür, ancak şişlik gerçek konturu daha uzun süre gizler. Sonucun çoğu üç ayda ortaya çıkar, nihai şekil altı–on ikinci ayda — gerekirse revizyonun da değerlendirileceği dönem budur."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Ön, yan ve arka görünümler hangi bölgelerin tedavi edilebileceğini, kabaca hangi hacmin gerçekçi olduğunu ve derinin toparlanıp toparlanmayacağını söylemek için yeterli. Koordinatörümüz plan ve yazılı fiyat teklifiyle döner.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Bu sayfa genel bilgilendirme amaçlıdır, tıbbi tavsiye değildir. Uygunluk, teknik ve riskler bir cerrahla yapılan görüşmede belirlenir.",
    "seoTitle": "İstanbul'da Liposuction (VASER) | Platinya Clinic",
    "seoDesc": "İstanbul'da liposuction: tumessan ve VASER teknikleri, 360° şekillendirme, uygun adaylar, iyileşme ve riskler. Ücretsiz değerlendirme."
  },
  "/gynecomastia": {
    "title": "İstanbul'da Jinekomasti Ameliyatı (Erkek Meme Küçültme)",
    "eyebrow": "Vücut şekillendirme",
    "lead": "Jinekomasti, erkek memesinin büyümesidir. Ameliyat meme ucunun altındaki bezi, çevresindeki yağı veya ikisini birlikte alır — ancak önce nedeni araştırıldıktan sonra; çünkü bazı nedenler tıbbidir ve bazıları geri dönüşlüdür.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te jinekomasti ön görüşmesi",
    "stats": [
      {
        "value": "1–2 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "Aynı gün",
        "label": "veya bir gece"
      },
      {
        "value": "3–4 hafta",
        "label": "Korse yelek"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Gerçek jinekomasti bez dokusudur — meme ucunun altında sert bir disk — ve egzersizle geçmez. Yalnızca yağ varsa buna yalancı jinekomasti denir ve tedavisi farklıdır.",
      "items": [
        "Bir veya iki meme ucunun altında sert, bazen hassas bir doku diski",
        "Ergenlikten sonra iki yıl veya daha uzun süre sabit kalmış büyüme",
        "Yalancı jinekomasti: bez olmadan yağ; kilosu sabite yakın kişilerde",
        "Rahatsızlık, asimetri ya da giyim ve günlük yaşamda kısıtlanma"
      ],
      "note": "Herhangi bir ameliyattan önce neden dışlanır. İlaçlar — esrar, anabolik steroidler, alkol, bazı tansiyon ve prostat ilaçları — en sık görülen geri dönüşlü nedendir. Hormonal sorunlar, tiroid hastalığı, karaciğer veya böbrek hastalığı ve nadiren bir testis tümörü de bu şekilde kendini gösterir. Önce kan testleri ve testis muayenesi yapılır; bir şey bulunursa ameliyatla etrafından dolaşılmaz, o tedavi edilir."
    },
    "techniques": {
      "heading": "Neler yapılabilir, teknik nasıl seçilir",
      "intro": "Ameliyat, gerçekte ne olduğuna — bez, yağ veya deri — göre planlanır ve bu üçü farklı erkeklerde farklı oranlarda bulunur.",
      "items": [
        {
          "name": "Bez eksizyonu",
          "text": "Bez, areolanın alt yarısını çevreleyen yarım daire şeklinde bir kesiyle çıkarılır. Sert bez dokusunu çıkarmanın tek yolu budur ve kesi pigmentin kenarını izlediği için genellikle iyi iyileşir. Sıklıkla bir–iki gün küçük bir dren bırakılır."
        },
        {
          "name": "Liposuction",
          "text": "Yağ bileşeni için ve göğsün ameliyatlı görünmemesi için kenarları yumuşatmakta kullanılır. Tek başına bezi çıkarmaz; bu yüzden yalnızca liposuction sıklıkla meme ucu altında sert bir yumru bırakır — revizyonun en sık nedeni budur."
        },
        {
          "name": "Deri alımıyla birlikte",
          "text": "Belirgin büyümede veya büyük kilo kaybı sonrası, kendini toplamayacak fazla deri vardır. İz areolanın çevresine veya göğsün ortasına yatay olarak yerleştirilerek alınır. Daha büyük bir ameliyat ve kabullenilmesi gereken bir iz demektir."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden iyileşmeye",
      "steps": [
        {
          "name": "Görüşme ve değerlendirme",
          "text": "Göğüs yatarken ve ayakta muayene edilir, bez yağdan ayrılır ve testisler kontrol edilir. Program yapılmadan önce hormon ve karaciğer fonksiyonu için kan testleri, gerektiğinde göğüs veya testis ultrasonu."
        },
        {
          "name": "Hazırlık",
          "text": "Neden olan ilaç varsa tedavi eden doktorun onayıyla kesilir — reçeteli bir ilacı asla kendi başınıza kesmeyin. Sigara dört hafta, kan sulandırıcılar yaklaşık on gün önce bırakılır ve altı–sekiz saat açlık gerekir. Korse yelek önceden sipariş edilir."
        },
        {
          "name": "Ameliyat",
          "text": "Genel anestezi altında, bir–iki saat. Bez çıkarılır, yağ liposuction ile alınır ve kontur siz otururken kontrol edilir. Yelek ameliyathanede giydirilir. Hastaların çoğu aynı gün eve gider, bazıları bir gece kalır."
        },
        {
          "name": "İlk iki hafta",
          "text": "Yelek gece gündüz giyilir; dren kullanıldıysa bir–iki günde çıkarılır. Şişlik ve morarma belirgindir, göğüs gergin hissedilir. Masa başı işe üç–yedi gün sonra; ağırlık ve göğüs egzersizi yok."
        },
        {
          "name": "Üçüncü–on ikinci haftalar",
          "text": "Yelek toplamda üç–dört hafta sürer. Aerobik egzersiz üç–dört haftada, ağırlık ve göğüs çalışması altı haftada. Şişlik üç ayda iner; küçük düzensizlikler dahil nihai kontur altıncı ayda değerlendirilir."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Buradaki risklerin çoğu konturla, biri de nedenin tedavi edilmeden bırakılmasıyla ilgilidir.",
      "items": [
        "Kontur bozukluğu — çukur bir çöküntü, kalan yumru veya iki taraf arasında asimetri; çok fazla ya da çok az doku alındığında",
        "Nüks; bez dokusu geride bırakılırsa veya nedene yol açan ilaç kullanılmaya devam edilirse",
        "Meme ucunda uyuşma veya aşırı hassasiyet; genellikle aylar içinde düzelir",
        "Kötü veya geniş iz; nadiren, kan akımı bozulursa meme ucu-areola kompleksinin kaybı",
        "Erken yürüyüşle azaltılan tromboz ve enfeksiyon — sigara içenlerde daha olası; hematom veya seroma drenaj gerektirebilir ve nihai şekli etkileyebilir"
      ],
      "note": "Ne kullandığınızı dürüstçe söyleyin — steroidler, esrar, takviyeler, reçeteli ilaçlar. Bu bir yargılama değil; işleyen bir ameliyatla geri gelen ameliyat arasındaki farkı belirleyen şey. Hormonal bir neden bulunursa ayrıca tedavi edilir."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Bu kanser mi?",
          "a": "Jinekomastinin kendisi meme kanseri değildir ve erkeklerde genellikle iyi huyludur. Ancak tek taraflı, sert, sabit veya akıntı yapan bir kitle aynı şey değildir ve araştırılmalıdır — bu yüzden muayene ve gerektiğinde ultrason ameliyattan sonra değil önce yapılır."
        },
        {
          "q": "Tekrarlar mı?",
          "a": "Bez düzgün çıkarılır ve neden ortadan kaldırılırsa nüks seyrektir. Yalnızca liposuction yapıldığında, meme ucunu korumak için bez bırakıldığında veya steroid/esrar kullanımı sürdüğünde daha sık geri gelir. Küçük bir kalıntı dolgunluk nüks ile aynı şey değildir."
        },
        {
          "q": "Esrar veya steroid kullanmayı bırakmam şart mı?",
          "a": "Evet — sadece iyileşme için değil. İkisi de büyümeyi tetikleyebilir ve ameliyat sonrası sürdürmek, sonucu geri almanın en güvenilir yoludur. Reçeteli ilaçlar farklıdır: yalnızca reçete eden doktorla değiştirilir."
        },
        {
          "q": "Görünür bir iz kalacak mı?",
          "a": "Kesi areolanın alt kenarını izler ve genellikle altı–on iki ayda ince bir çizgiye dönüşür. Deri alınması gerekirse iz daha uzundur — areolanın çevresinde veya göğsün ortasında. Kalıcıdır ve ameliyatın ana bedeli budur."
        }
      ]
    },
    "ctaBand": {
      "heading": "İlk görüş için fotoğraflarınızı gönderin",
      "text": "Bir ön ve bir yan görünüm, bunun bez mi, yağ mı yoksa deri mi olduğunu ve her şeyden önce kan testi gerekip gerekmediğini değerlendirmek için yeterli. Koordinatörümüz plan ve yazılı fiyat teklifiyle döner.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Bu sayfa genel bilgilendirme amaçlıdır, tıbbi tavsiye değildir. Uygunluk, teknik ve riskler bir cerrahla yapılan görüşmede belirlenir.",
    "seoTitle": "Jinekomasti Ameliyatı İstanbul | Platinya Clinic",
    "seoDesc": "İstanbul'da jinekomasti ameliyatı: bez eksizyonu, liposuction, uygun adaylar, nedenler ve riskler. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/gastric-sleeve-surgery": {
    "title": "İstanbul'da Tüp Mide Ameliyatı",
    "eyebrow": "Obezite cerrahisi",
    "lead": "Mide, dar bir tüp hâline getirilir — yaklaşık %60–70'i çıkarılır — böylece çok daha az alır ve daha yavaş boşalır. İştahı ve porsiyon boyutunu yönetmeyi kolaylaştıran bir araçtır; sizin yerinize kilo vermez.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te tüp mide ön görüşmesi",
    "stats": [
      {
        "value": "1–2 saat",
        "label": "Ameliyat süresi"
      },
      {
        "value": "2–3 gece",
        "label": "Hastanede kalış"
      },
      {
        "value": "12–18 ay",
        "label": "Kilonun oturması"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Karar yalnızca kiloya göre verilmez. Vücut kitle indeksine, fazla kilonun getirdiği hastalıklara, gözetim altında şimdiye kadar nelerin denendiğine ve aylarca değil yıllarca takip edilmeye gerçekten istekli olmaya dayanır.",
      "items": [
        "VKİ 40 ve üzeri; ya da tip 2 diyabet, yüksek tansiyon veya uyku apnesi gibi kiloya bağlı bir hastalıkla birlikte 35 ve üzeri",
        "Kontrol altına alınamayan tip 2 diyabetle birlikte VKİ 30 ve üzeri — bazı uluslararası kılavuzların izin verdiği, olgu bazında karar verilen durum",
        "Daha önce yapılandırılmış kilo verme girişimleri — diyet, hareket, davranışsal destek — ve bunların uzun vadede kalıcı olmaması",
        "Ömür boyu takibe bağlılık: kan testleri, takviyeler ve klinik kontrolleri, kilonun sabit kaldığı yıllar dahil"
      ],
      "note": "Psikolojik değerlendirme, anestezi muayenesi ve diyetisyen değerlendirmesi yapılmadan hiçbir ameliyat planlanmaz. Aktif madde kötüye kullanımı veya tedavi edilmemiş psikiyatrik hastalık, tedavi edilene kadar ameliyatı erteler — bir kural olduğu için değil, aksi hâlde takibin sürmeyeceği için."
    },
    "techniques": {
      "heading": "Ameliyat nasıl yapılır",
      "intro": "İlke her olguda aynıdır; değişen, geride bırakılan tüpün çapı ve aynı seansta fıtık onarılıp onarılmadığıdır.",
      "items": [
        {
          "name": "Laparoskopik tüp mide",
          "text": "Beş–altı küçük kesi, bir kamera ve mideyi büyük kurvatur boyunca ayıran staplerlar. Açık kalan kısım portlardan birinden çıkarılır; geride kalan mide, bypass'lı bir poş değil bir tüptür."
        },
        {
          "name": "Kalibrasyon — tüpün darlığı",
          "text": "Tüp, ağızdan geçirilen bir kalibrasyon tüpü üzerine kurulur; tipik olarak 36–40 French. Daha dar tüp daha fazla kısıtlama ama daha fazla darlık ve reflü, daha geniş tüp daha azı demektir. Bu bir hasta tercihi değil, cerrahi bir karardır."
        },
        {
          "name": "Hiatal herni onarımı ve reflü",
          "text": "Diyafram ameliyat sırasında kontrol edilir ve hiatal herni bulunursa aynı seansta onarılır. Zaten var olan reflü tüp mideden sonra kötüleşebilir; bu yüzden önceden değerlendirilir ve bazen seçilen ameliyatı değiştirir."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden uzun vadeli takibe",
      "steps": [
        {
          "name": "Değerlendirme",
          "text": "Demir, B12, folat, D vitamini ve tiroid fonksiyonlarını içeren kan testleri; gerektiğinde endoskopi; diyetisyen değerlendirmesi; psikolojik değerlendirme ve anestezi görüşü. Ancak bundan sonra tarih önerilir."
        },
        {
          "name": "Önceki iki hafta",
          "text": "Düşük kalorili, genellikle sıvı veya çok düşük enerjili bir diyet karaciğeri küçültür, böylece mideye güvenle ulaşılabilir. Sigara en az dört hafta önce bırakılır. Kan sulandırıcılar talimatla kesilir."
        },
        {
          "name": "Ameliyat ve hastane süreci",
          "text": "Genel anestezi altında, bir–iki saat. Hastaların çoğu iki–üç gece kalır. Stapler hattıyla ilgili bir kuşku varsa birinci veya ikinci gün kontrastlı görüntüleme yapılır ve sıvı alımı aynı gün başlar."
        },
        {
          "name": "İlk altı hafta",
          "text": "Bir–iki hafta sıvı, iki hafta püre, iki hafta yumuşak gıda, sonra normal kıvamlar. Küçük porsiyonlar, yavaş yemek, önce protein ve sıvıları öğünlerden ayrı tutmak. Masa başı işe genellikle iki–üç hafta sonra dönülür."
        },
        {
          "name": "Uzun vade",
          "text": "Ömür boyu B12 vitamini, demir, folat, D vitamini ve kalsiyum; üçüncü, altıncı ve on ikinci aylarda, sonra yılda bir kan testleri. Takip kilo durduğunda da sürer — eksiklikler ve yeniden kilo alımı o dönemde ortaya çıkar."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Tüp mide, sağlıklı bir organda kalıcı bir değişikliktir. Bunlar hastaların gerçekten uyarıldığı komplikasyonlardır ve ameliyatın neden obezite cerrahisi desteği olan bir hastanede yapıldığının nedeni de budur.",
      "items": [
        "Hastaların yaklaşık %1–3'ünde stapler hattından kaçak; genellikle 3.–10. günler arasında. Drenaj, bazen stent, nadiren ek ameliyat gerekir",
        "Stapler hattından veya dalaktan kanama; transfüzyon ve nadiren yeniden ameliyat gerekebilir",
        "Tüpün daralması veya bükülmesi; tekrarlayan kusma ve yutma güçlüğüne yol açar, endoskopik dilatasyonla tedavi edilir",
        "Yeni başlayan veya kötüleşen asit reflü — tüp mide sonrası en sık şikâyetlerden biri ve bazı hastaların bypass'a yönlendirilmesinin nedeni",
        "Takviyeler ve izlem aksarsa uzun vadede B12, demir, folat, D vitamini ve kalsiyum eksikliği"
      ],
      "note": "Yeniden kilo alımı olur; çoğu zaman üçüncü yıldan itibaren, porsiyonlar yeniden büyüdüğünde ve takip bırakıldığında. Ameliyat bir araçtır, tedavi değil: yeme alışkanlıklarının yeniden kurulabileceği bir pencere açar ve içinde hiçbir şey kurulmazsa o pencere kapanır."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ne kadar kilo veririm?",
          "a": "Genellikle ilk bir–iki yılda toplam vücut ağırlığının yaklaşık %25–30'u; ancak hastalar arasındaki aralık geniştir ve başlangıç kilosuna, uyuma ve takibe bağlıdır. Kimse değerlendirmeden önce bir rakam garanti edemez."
        },
        {
          "q": "Ömür boyu takviye kullanacak mıyım?",
          "a": "Çoğu olguda evet — B12 vitamini, demir, folat, D vitamini ve kalsiyum, dozları ayarlamak için kan testleriyle. Çıkarılan mide intrinsik faktör ve asit üretir; emilim kalıcı olarak değişir."
        },
        {
          "q": "Geri alınabilir mi?",
          "a": "Mide eski şekline döndürülmez. Tüp mide başarısız olursa — şiddetli reflü, yetersiz kilo kaybı, yeniden alım — genellikle sonraki adım, daha büyük bir ameliyat olan gastrik bypass'a dönüşümdür."
        },
        {
          "q": "Sonrasında hamilelik?",
          "a": "Hamilelik mümkündür, ancak çoğu cerrah kilonun ve beslenme durumunun stabil olması için 12–18 ay beklemeyi önerir. Takviyeler ve izlem hamilelik boyunca sürer."
        }
      ]
    },
    "ctaBand": {
      "heading": "Boyunuzu, kilonuzu ve tıbbi geçmişinizi gönderin",
      "text": "Bir obezite cerrahı bunları inceler; koordinatörümüz değerlendirmenin mantıklı olup olmadığını, önce hangi testlerin gerekeceğini ve yazılı fiyat teklifini iletir — randevu alma zorunluluğu yok.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk ancak bir obezite cerrahının psikolojik ve beslenme değerlendirmesini de içeren tam muayenesinden sonra belirlenebilir; sonuçlar ve riskler hastadan hastaya değişir.",
    "seoTitle": "İstanbul'da Tüp Mide Ameliyatı | Platinya Clinic",
    "seoDesc": "İstanbul'da tüp mide: kimler uygun aday, ameliyat süreci, beslenme evreleri, riskler ve ömür boyu takip. Ücretsiz değerlendirme."
  },
  "/stomach-balloon": {
    "title": "İstanbul'da Mide Balonu",
    "eyebrow": "Obezite tedavisi",
    "lead": "Mideye bir balon yerleştirilip şişirilir; böylece yemeğe daha az yer kalır ve daha çabuk doyarsınız. Altı–on iki ay kalır ve sonra çıkarılır. Ameliyat değil, obezite tedavisi de değil; geçici bir yardımcıdır.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te mide balonu ön görüşmesi",
    "stats": [
      {
        "value": "20–30 dk",
        "label": "Yerleştirme"
      },
      {
        "value": "6–12 ay",
        "label": "Kalma süresi"
      },
      {
        "value": "3–7 gün",
        "label": "Uyum süresi"
      }
    ],
    "candidate": {
      "heading": "Kimler uygun adaydır",
      "intro": "Balon; başka bir şeyden önce — eklem ameliyatı, kısırlık tedavisi, fıtık onarımı — anlamlı miktarda kilo vermesi gereken ya da gözetim altında yeme alışkanlıklarını değiştirmek için tanımlı bir başlangıç dönemine ihtiyaç duyan kişiye uygundur. İşi tek başına yapacak bir işlem arayan birine uygun değildir.",
      "items": [
        "Kabaca 27–35 arası VKİ ve endoskopiyi güvensiz kılacak bir hastalık olmaması",
        "Gözetimli diyet ve hareketle yanıt vermemiş kilo ya da hızlı kilo vermek için tıbbi bir neden",
        "Geçirilmiş mide veya yemek borusu ameliyatı, büyük hiatal herni veya aktif ülser olmaması",
        "Balonun kaldığı aylar boyunca ve çıkarıldıktan sonra diyet programına uymaya istekli olmak"
      ],
      "note": "Balon, tek başına VKİ 40 üzeri için bir tedavi değildir; hamile olanlara, bir yıl içinde hamilelik planlayanlara veya aktif yeme bozukluğu olanlara önerilmez. Tarama; tıbbi geçmiş, kan testleri ve cihaza bağlı olarak endoskopiyi içerir."
    },
    "techniques": {
      "heading": "Balonun yerleştirilmesinin iki yolu",
      "intro": "İkisi de midede yer kaplar. Farklı olan, oraya nasıl ulaştıkları, ne kadar kalabildikleri ve sedasyon gerekip gerekmediğidir.",
      "items": [
        {
          "name": "Endoskopik balon",
          "text": "Sedasyon altında gastroskopla ağızdan yerleştirilir, ardından serum fizyolojik ve bir boya ile doldurulur; böylece bir sızıntı görülebilir. Yaklaşık 20–30 dakika sürer. Ruhsatlı süresinin sonunda, genellikle altı veya on iki ayda, aynı yolla çıkarılır."
        },
        {
          "name": "Yutulabilir balon",
          "text": "Bir kapsül su ile yutulur, röntgende kontrol edilir, sonra ince bir kateterle gazla doldurulur. Sedasyon ve endoskopi yok. Yaklaşık dört ay kalır ve doğal yolla atılacak şekilde tasarlanmıştır; ancak bazen endoskopiyle çıkarılması gerekir."
        },
        {
          "name": "Etrafındaki program",
          "text": "Hiçbir cihaz, beraberindeki diyet olmadan işe yaramaz: diyetisyen yönetiminde bir plan, protein hedefleri, davranışsal takip ve çıkarılmadan önceki haftalarda normal yeme düzenine yapılandırılmış bir geçiş. Sonucu belirleyen kısım budur."
        }
      ]
    },
    "journey": {
      "heading": "Taramadan çıkarılma sonrasına",
      "steps": [
        {
          "name": "Tarama",
          "text": "Tıbbi geçmiş, ilaç gözden geçirmesi, kan testleri ve cihaz gerektiriyorsa endoskopi. Varsa ülser, fıtık veya reflü yerleştirmeden sonra değil önce tedavi edilir."
        },
        {
          "name": "Yerleştirme günü",
          "text": "Genellikle aynı gün taburcu. Endoskopik sürümde sedasyon; yutulabilir olanda yalnızca su ve bir kapsül. Birkaç saat gözlenir, bulantı önleyici ilaç verilir ve aynı gün eve dönülür."
        },
        {
          "name": "İlk hafta",
          "text": "Bulantı, kramp ve kusma sık ve beklenen durumlardır — mide içindeki bir şeye itiraz ediyordur. Bulantı önleyici tabletler, az miktarda sıvı ve gerekirse damardan sıvı. Çoğu kişi üç–yedi gün içinde rahatlar."
        },
        {
          "name": "Balonun kaldığı aylar",
          "text": "İki–üç hafta içinde sıvı, ardından yumuşak gıda, sonra normal kıvamlar. Porsiyonlar daha küçüktür çünkü mide daha küçüktür. Dört–altı haftada bir diyetisyen kontrolü; alım düşük kalırsa kan testleri."
        },
        {
          "name": "Çıkarılma ve sonrası",
          "text": "Çıkarma 20–30 dakika sürer. İştah genellikle günler–haftalar içinde geri gelir ve program boyunca kurulan alışkanlıklar yoksa kilo geri döner. Balon çıkarılmadan önce bir idame planı — diyetisyen takibi, hareket, bazen ilaç — kararlaştırılır."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Balon ameliyattan daha az invazivdir, risksiz değildir. Yerleştirmeden önce konuşulan komplikasyonlar bunlar.",
      "items": [
        "İlk haftada bulantı, kusma ve karın krampları; bazen damardan sıvı gerektirecek kadar şiddetli",
        "Balon yerindeyken reflü, mide yanması ve yemek borusu veya mide iç yüzeyinde tahriş",
        "Balonun sönmesi veya yer değiştirmesi; bağırsağı tıkayabilir — seyrek, ama olduğunda acil bir durumdur",
        "Ülserleşme, erozyon veya çok nadiren mide duvarında perforasyon; ameliyat gerektirir",
        "Çıkarıldıktan sonra yeniden kilo alımı; diyet programı sürdürülmediğinde sık görülür"
      ],
      "note": "Balon zaman ve daha küçük bir mide satın alır, fazlasını değil. Vücudun yemeği nasıl ele aldığını değiştirmez, yemenin neden zor olduğunu tedavi etmez ve verilen kilo genellikle ölçülüdür — çoğu zaman yerinde kaldığı sürede vücut ağırlığının %5–15'i arasında."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ne kadar kilo veririm?",
          "a": "Genellikle yerinde kaldığı sürede vücut ağırlığının %5–15'i civarında, geniş bir değişkenlikle. Tüp mide veya bypass'tan azdır ve bir kısmı çıkarıldıktan sonra sıklıkla geri alınır."
        },
        {
          "q": "Ağrılı mı?",
          "a": "Yerleştirme ağrılı değildir — boğaz uyuşturulur ve sedasyon kullanılır. İlk üç–yedi gün genellikle rahatsız edicidir: bulantı, kramp ve kusma. Eve gitmeden önce bulantı önleyici ilaç reçete edilir."
        },
        {
          "q": "Bununla normal yemek yiyebilir miyim?",
          "a": "Normal kıvamlar evet; normal porsiyonlar hayır. Çok hızlı veya çok fazla yemek ağrı ve kusmaya yol açar; gazlı içecekler ve çok lifli gıdalar bazı hastalar tarafından iyi tolere edilmez."
        },
        {
          "q": "Çıkarıldığında ne olur?",
          "a": "Mide günler içinde önceki boyutuna döner. İştah sıklıkla hızla geri gelir. Kilonun kalıp kalmaması, o aylarda ne kurulduğuna bağlıdır; diyet programının cihazdan daha önemli olmasının nedeni budur."
        }
      ]
    },
    "ctaBand": {
      "heading": "Balonun doğru başlangıç olup olmadığını öğrenin",
      "text": "Boyunuzu, kilonuzu ve tıbbi geçmişinizi gönderin. Bir obezite hekimi bunları inceler; koordinatörümüz olgunuza balonun mu yoksa cerrahi değerlendirmenin mi uyduğunu ve neleri kapsadığını iletir.",
      "button": "Koordinatörle görüşün"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Uygunluk; tıbbi geçmiş ve gerektiğinde endoskopiyi içeren bir obezite hekimi değerlendirmesine bağlıdır; sonuçlar hastadan hastaya değişir.",
    "seoTitle": "İstanbul'da Mide Balonu | Platinya Clinic",
    "seoDesc": "İstanbul'da mide balonu: endoskopik ve yutulabilir balon, kimler için uygun, kilo kaybı beklentisi, riskler. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/filler": {
    "title": "İstanbul'da Yüz Dolgusu",
    "eyebrow": "Estetik tıp",
    "lead": "Hyalüronik asit, derinin zaten içerdiği bir şekerdir. Jel hâline getirilip deri altına yerleştirildiğinde kaybedilen hacmi geri kazandırır ve yerleşmiş kıvrımları yumuşatır. Gerçek riskleri olan tıbbi bir işlemdir, güzellik bakımı değildir.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te yüz dolgusu ön görüşmesi",
    "stats": [
      {
        "value": "30–60 dk",
        "label": "Randevu"
      },
      {
        "value": "6–18 ay",
        "label": "Kalıcılık"
      },
      {
        "value": "24–72 saat",
        "label": "Şişlik ve morarma"
      }
    ],
    "candidate": {
      "heading": "Kime uygun, kime değil",
      "intro": "Doğru adayın, başkasına benzeme isteği değil; somut ve tarif edilebilir bir derdi vardır — bir kıvrım, bir çöküklük, kaybolmuş bir kontur. Hacim, gittiği yere konur; konabilecek her yere değil.",
      "items": [
        "Elmacık kemiklerinde, şakaklarda veya orta yüzde hacim kaybı; ya da yüz dinlenirken de kalan kıvrımlar",
        "Belirginliğini kaybetmiş çene hattı veya çene; ya da hiç hacimli olmadığı hâlde değil, yaşla incelmiş dudaklar",
        "Genel sağlığı iyi olmak; tedavi edilecek bölgede aktif enfeksiyon veya deri iltihabı olmaması",
        "Gerçekçi beklentiler: dolgu hacmi geri kazandırır, sarkmış bir yüzü kaldırmaz ve deri gevşekliğini gidermez"
      ],
      "note": "Dolgu hamilelikte ve emzirmede, aktif akne, uçuk veya enfeksiyon üzerine, ya da hyalüronik aside veya lidokaine bilinen alerji varsa uygulanmaz. Kan sulandırıcılar ve bazı takviyeler morarma riskini artırır ve göz ardı edilmez, önceden değerlendirilir. Kalıcı dolgu isteyen herkes reddedilir ve bunun yerine cerrahi görüş önerilir."
    },
    "techniques": {
      "heading": "Ürün, katman ve miktar",
      "intro": "Sonuç, kutunun üzerindeki markadan çok, ürünün nereye yerleştirildiğine ve ne kadar kullanıldığına bağlıdır.",
      "items": [
        {
          "name": "Jelin seçimi",
          "text": "Hyalüronik asit dolguları, ne kadar yoğun çapraz bağlandıklarına ve jelin ne kadar sert olduğuna göre farklılaşır. Dudaklar ve ince çizgiler için daha yumuşak, kemik üzerindeki derin katmanlar için daha sert jeller. Çoğu lidokain içerir, bu da enjeksiyonu daha konforlu kılar."
        },
        {
          "name": "İğne mi kanül mü, hangi katman",
          "text": "İğne dudaklar ve ince kıvrımlar için hassastır; künt kanül morarmayı azaltır ve ürünün tek bir hat boyunca verilmesini sağlar. Kemik üzerine derin yerleştirme destek verir; yüzeysel yerleştirme rötuş yapar. Katman bir tercih değil, klinik bir karardır."
        },
        {
          "name": "Temkinli ve aşamalı dozlama",
          "text": "Az doldurup iki–dört haftada kontrol etmek, tek seansta düzeltmekten daha güvenlidir. Aşırı doldurulan doku gerilir ve gerilen deri geri büzülmez — yüzlerin dinlenmiş değil, doldurulmuş görünmesinin nedeni budur."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden kontrole",
      "steps": [
        {
          "name": "Görüşme",
          "text": "Yüz dinlenirken ve hareket hâlinde değerlendirilir, fotoğraf çekilir ve tıbbi geçmiş gözden geçirilir — hamilelik, otoimmün hastalık, uçuk, önceki dolgular ve nereye yapıldıkları. Önceden yapılmış kalıcı dolgu planı tamamen değiştirir."
        },
        {
          "name": "Planlama ve onam",
          "text": "Bölgeler, ürün, hacim ve maliyet herhangi bir ürün açılmadan önce yazılı olarak kararlaştırılır. Riskler, damar tıkanıklığı dahil anlatılır ve ürünü çözen enzim olan hyalüronidazın klinikte hazır bulundurulduğu size söylenir."
        },
        {
          "name": "Randevu",
          "text": "Uyuşturucu krem dahil otuz–altmış dakika. Enjeksiyonlar bunun on–yirmi dakikasını alır. Dudaklar ve gözyaşı olukları en hassas bölgelerdir; çoğu kişi ağrıdan çok basınç tarif eder."
        },
        {
          "name": "İlk 72 saat",
          "text": "Şişlik 24–48 saatte zirve yapar, morarmanın geçmesi bir haftayı bulabilir. 24–48 saat sıcak, sauna, yoğun egzersiz ve alkolden; dudak veya nazolabial bölgeye işlem yapıldıysa iki hafta diş tedavisinden uzak durun. İlk gece hafif yüksekte yatmak yardımcı olur."
        },
        {
          "name": "İki–dört hafta sonra kontrol",
          "text": "Sonuç, şişlik geçtikten sonra değerlendirilir. Bazen küçük bir ek doz uygun olur; ilk hafta, her şey olduğundan büyük görünürken düzeltme yapılmaz. Sonraki tedavi, ürünün dokunuzda gerçekte ne kadar kaldığına göre planlanır."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Bunlar damarsal bir bölgeye yapılan tıbbi enjeksiyonlardır. Ciddi riskler seyrek görülür, ancak bu işlemin neden doktorun bulunduğu ve buzdolabında çözücü ajanın hazır olduğu bir klinikte yapılması gerektiğinin nedeni de budur.",
      "items": [
        "Birkaç gün süren morarma, şişlik ve hassasiyet — sık görülür, kan sulandırıcı kullananlarda daha fazla",
        "Damar tıkanıklığı — ürünün bir atardamarı tıkaması; ağrı, soluklaşma ve tedavi edilmezse deri nekrozu ile izlenebilir; hyalüronidaz saatler içinde verilmelidir",
        "Retinal dolaşıma emboli sonucu görme kaybı — çok nadir, büyük ölçüde geri dönüşsüz; bazı bölgelerin yalnızca deneyimli uygulayıcılar tarafından tedavi edilmesinin nedeni",
        "Yumrular, nodüller veya aylar sonra gecikmiş iltihabi reaksiyonlar; bazen hastalık veya aşı ile tetiklenir",
        "Asimetri, ürünün kayması ya da tek seansta tamamen geri alınamayan aşırı dolu görünüm"
      ],
      "note": "Hyalüronik asit hyalüronidazla çözülebilir; yüzde kullanmaya değer tek dolgu olmasının nedeni budur. Kalıcı ürünler ve etiketsiz maddeler çıkarılamaz ve bir hastanın geri çevrilmesinin ya da ameliyata yönlendirilmesinin en sık nedeni bunlardır."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Ağrı olur mu?",
          "a": "Yirmi–otuz dakika uyuşturucu krem uygulanır ve çoğu ürün lidokain içerir. Dudaklar ve göz altı en hassas bölgelerdir — ağrıdan çok rahatsızlık ve her enjeksiyonda saniyeler sürer."
        },
        {
          "q": "Geri alınabilir mi?",
          "a": "Hyalüronik asitse evet: hyalüronidaz bir–iki gün içinde çözer. Bu, aşırı doldurmak için bir neden değil; ama ürünün fiyattan daha önemli olmasının nedenidir."
        },
        {
          "q": "Belli olur mu?",
          "a": "Doğru katmana yerleştirilip temkinli kalınırsa hayır. Bariz bir sonuç genellikle, hacimden çok desteğe ihtiyaç duyan bir bölgeye, çok fazla ürünün çok yüzeysel verilmesi anlamına gelir."
        },
        {
          "q": "Ne sıklıkla ek yaptırmam gerekir?",
          "a": "Ürüne, bölgeye ve ne kadar hızlı parçalandığına bağlı olarak altı–on sekiz ayda bir. Dudaklar ve çok hareket eden bölgeler, derin elmacık desteğine göre daha erken ek doz ister."
        }
      ]
    },
    "ctaBand": {
      "heading": "Yüzünüzün gerçekte neye ihtiyacı olduğunu bir doktora sorun",
      "text": "İki fotoğraf gönderin — önden ve üç çeyrek, dinlenirken — bir doktor incelesin. Dolgunun doğru tedavi olup olmadığına ve başka neyin olabileceğine dair dürüst bir cevap alırsınız.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Dolgular reçeteli tıbbi cihazlardır ve yalnızca yetkin bir uygulayıcıyla görüşmeden sonra uygundur; uygunluk hastadan hastaya değişir.",
    "seoTitle": "İstanbul'da Yüz Dolgusu | Platinya Clinic",
    "seoDesc": "İstanbul'da hyalüronik asit dolgu: bölgeler, ürün seçimi, kalıcılık, damar tıkanıklığı riski ve bakım. Platinya Clinic'te ücretsiz değerlendirme."
  },
  "/face-botox": {
    "title": "İstanbul'da Yüz Botoksu",
    "eyebrow": "Estetik tıp",
    "lead": "Botulinum toksini, kasın kasılmasını söyleyen sinyali bloke eder. Üst yüze küçük ve ölçülü dozlarda uygulandığında, mimiklerin kazıdığı çizgileri yumuşatır — ve etkisi geçicidir, ki asıl mesele de budur.",
    "cta": "Ücretsiz değerlendirme için randevu alın",
    "heroAlt": "Platinya Clinic'te botulinum toksini ön görüşmesi",
    "stats": [
      {
        "value": "15–30 dk",
        "label": "Randevu"
      },
      {
        "value": "10–14 gün",
        "label": "Tam etki"
      },
      {
        "value": "3–4 ay",
        "label": "Etki süresi"
      }
    ],
    "candidate": {
      "heading": "Kime uygun, kime değil",
      "intro": "Toksin, mimikle oluşan çizgileri tedavi eder. Kaybedilen hacim veya sarkmış deri için hiçbir şey yapmaz — bunlar dolgu ya da cerrahi gerektirir ve bunlara toksin önermek, hastaların hayal kırıklığına uğramasının nedenidir.",
      "items": [
        "Kaş arasındaki çatıklık çizgileri, alındaki yatay çizgiler ve mimikle görünen kaz ayakları",
        "Hâlâ dinamik olan, yani kaş çatınca veya gülünce beliren, dinlenirken kazınmamış çizgiler",
        "Genel sağlığı iyi olan ve reçeteli bir ilacı kullanmaması için bir neden bulunmayan kişiler",
        "Gerçekçi beklentiler: yüz daha az gergin görünür, daha genç değil; ve etki geçicidir"
      ],
      "note": "Botulinum toksini hamilelikte ve emzirmede; myastenia gravis, Lambert–Eaton sendromu veya motor nöron hastalığı gibi nöromusküler bir hastalığı olanlarda; ürüne ya da taşıyıcısı albumine bilinen alerjisi olanlarda uygulanmaz. Enjeksiyon bölgesinde aktif enfeksiyon ve mevcut göz kapağı düşüklüğü, beklemek veya farklı tedavi etmek için görece nedenlerdir."
    },
    "techniques": {
      "heading": "Nereye, ne kadar",
      "intro": "Dozlar her markaya özgü ünitelerdir ve markalar arasında karşılaştırılamaz. Önemli olan, kaslarınızın gerçekte nasıl hareket ettiğine göre seçilen enjeksiyon desenidir.",
      "items": [
        {
          "name": "Glabella — çatıklık çizgileri",
          "text": "Genellikle ilk tedavi edilen bölge; tipik olarak beş enjeksiyon noktasına 20–30 ünite. Sonucu en öngörülebilir bölgedir ve aynı zamanda yanlış yerleştirilen dozun göz kapağı düşüklüğüne yol açabileceği bölgedir."
        },
        {
          "name": "Alın",
          "text": "Tipik olarak 10–20 ünite; yatay çizgileri kaşı tamamen düzleştirmeden yumuşatacak şekilde yerleştirilir. Alnı tek başına, glabella olmadan tedavi etmek çoğu zaman iç kaşı yukarı kaldırır ve tuhaf görünür — bölgeler birlikte planlanır."
        },
        {
          "name": "Kaz ayakları",
          "text": "Tipik olarak her tarafa 6–12 ünite, gözün dış çevresinde üç nokta. Yüzeysel ve orbital kenara yakın olduğu için morarma sıktır; ağır ve kapalı bir görünümden kaçınmak için doz düşük tutulur."
        }
      ]
    },
    "journey": {
      "heading": "Görüşmeden kontrole",
      "steps": [
        {
          "name": "Görüşme",
          "text": "Yüz dinlenirken ve hareket hâlinde gözlenir — kaş çatma, kaldırma, göz kısma — çünkü doz çizgiye göre değil kasa göre seçilir. Tıbbi geçmiş, ilaçlar ve önceki toksin tedavileri gözden geçirilir, fotoğraf çekilir."
        },
        {
          "name": "Randevu",
          "text": "On beş–otuz dakika. Anestezi gerekmez; isterseniz buz uygulanır. İnce iğne, birkaç küçük enjeksiyon, her biri birkaç saniye. Hemen işe dönebilirsiniz."
        },
        {
          "name": "İlk 24 saat",
          "text": "Dört saat bölgeyi ovmamak veya masaj yapmamak, dört saat yatmamak, 24 saat spor salonu, sauna ve alkolden uzak durmak. Hafif baş ağrısı ve küçük morluklar sık görülür; deri bütünlüğü bozulmadıysa aynı gün makyaj yapılabilir."
        },
        {
          "name": "3.–14. günler",
          "text": "Etki ikinci–üçüncü gün başlar ve tam etkiye 10–14 günde ulaşılır. Bundan erken değerlendirmek gereksiz ek dozlara yol açar — kontrol 14. güne planlanır."
        },
        {
          "name": "Kontrol ve idame",
          "text": "İki haftada desen kontrol edilir ve gerekirse küçük bir düzeltme yapılır. Etki üç–dört ay sürer, hızlı metabolize edenlerde bazen daha kısa. Üç–dört ayda bir tedavi, dozları yükseltmeden sonucu istikrarlı tutar."
        }
      ]
    },
    "risks": {
      "heading": "Neler ters gidebilir",
      "intro": "Bu reçeteli bir ilaçtır ve riskler iğnenin değil, toksinin kendisinden kaynaklanır.",
      "items": [
        "Bir–iki gün süren morarma, şişlik ve hafif baş ağrısı; en sık göz çevresinde",
        "Glabella tedavilerinin yaklaşık %1–2'sinde göz kapağı veya kaş düşüklüğü (pitozis) — geçicidir, iki–dört haftada düzelir, bazen göz damlasıyla desteklenir",
        "Asimetri veya bir kaşın daha yüksek durması; genellikle iki haftalık kontrolde düzeltilebilir",
        "Kaslarla uyuşmayan bir doz veya desenden kaynaklanan yapay ifade — düzleşmiş alın ya da «Spock kaşı»",
        "Kuru göz, göz kapağı şişliği veya kaşı kaldırmakta zorluk; nadiren genel halsizlik ya da gribe benzer tepki"
      ],
      "note": "Uygulayıcıya her ilacı ve takviyeyi, önceki toksin tedavilerini ve bunların ne kadar sürdüğünü, ailede nöromusküler hastalık öyküsü olup olmadığını söyleyin. Toksin sarkmış deriyi veya kaybedilen hacmi tedavi etmez; yüzün gerçekte ihtiyacı cerrahiyse, cerrahi görüşün yerini tutmaz."
    },
    "faq": {
      "heading": "Hastaların sorduğu sorular",
      "items": [
        {
          "q": "Yüzüm donuk görünür mü?",
          "a": "Ölçülü dozda hayır. Amaç hareketi durdurmak değil yumuşatmak. Donuk görünüm, her bölgenin tam dozda tedavi edilmesinden kaynaklanır — ve geri dönüşü vardır, cerrahiye göre avantajı budur."
        },
        {
          "q": "Sonucu ne zaman görürüm?",
          "a": "Mimikler ikinci–üçüncü gün yumuşamaya başlar ve tam etki 10–14 günde ortaya çıkar. Ondan önce asimetrik görünen şey genellikle hâlâ gelişmektedir."
        },
        {
          "q": "Bırakırsam ne olur?",
          "a": "Kas birkaç ay içinde önceki aktivitesine döner ve çizgiler eski hâline gelir. Geri tepme şeklinde kötüleşme olmaz; ancak yıllarca baskılanmış çizgiler başlangıçta daha yerleşik görünebilir."
        },
        {
          "q": "Dolguyla birleştirilebilir mi?",
          "a": "Çoğu zaman evet — mimik için toksin, hacim için dolgu — ve sık sık aynı ziyarette yapılır. Sıra ve zamanlamaya uygulayıcı karar verir, çünkü ikisi de yüzün değerlendirilme biçimini değiştirir."
        }
      ]
    },
    "ctaBand": {
      "heading": "Toksinin doğru cevap olup olmadığını bir doktora sorun",
      "text": "İki fotoğraf gönderin — kaş çatarken ve dinlenirken — bir doktor incelesin. Çizgilerin kastan mı kaynaklandığına ve kaynaklanmıyorsa başka neye ihtiyaç olduğuna dair dürüst bir cevap alırsınız.",
      "button": "Fotoğraflarınızı gönderin"
    },
    "disclaimer": "Genel bilgilendirme, tıbbi tavsiye değil. Botulinum toksini reçeteli bir ilaçtır ve yalnızca yetkin bir uygulayıcıyla görüşmeden sonra uygulanır; uygunluk ve doz hastadan hastaya değişir.",
    "seoTitle": "İstanbul'da Yüz Botoksu | Platinya Clinic",
    "seoDesc": "İstanbul'da yüz botoksu: glabella, alın ve kaz ayakları dozları, etki süresi, riskler ve bakım. Platinya Clinic'te ücretsiz değerlendirme."
  }
};
